export default {
  average_power_savings_per_ton_of_Paper:"Average Power Savings per Ton of Paper",//平均吨纸电耗节省
	CO2_price:"CO₂ price",//CO₂价格
	"current_water_price":"Current water price",//今日水价
	"total_wate_saving":"Total Water Saving",//节水总量
	"tiered_electricity_pricing":"Tiered Electricity Pricing",//分段电价
  "annual_energy_savings_of_intelligent_systems": "Annual Energy Savings of Intelligent Systems",//智能系统年度节能总收益
  "annual_electricity_savings_of_intelligent_systems": "Annual Electricity Savings of Intelligent Systems",//智能系统年度节电收益
  "annual_coal_savings_of_intelligent_systems": "Annual Coal Savings of Intelligent Systems",//智能系统年度节煤收益
  "annual_co2_reduction_of_intelligent_systems": "Annual CO₂ Reduction of Intelligent Systems",//智能系统年度CO₂排放收益
  "annual_water_savings_of_intelligent_systems": "Annual Water Savings of Intelligent Systems",//智能系统年度节水收益
	"节水量":"Water Saving",
	"水费单价":"Water Cost Per Unit",
  图表最多展示6个测点:
    "The chart can display a maximum of 6 measurement points!",
  最多置顶展示两个测点:
    "A maximum of 2 measurement points can be pinned at the top!",
  返回机组: "Return to Unit",
  电厂: "Power Plant-",
  设备巡检: "Auditing",
  编辑账号: "Edit account",
  设备出厂: "Equipment Factory Out",
  安装调试: "Installation and Commissioning",
  设备质保到期: "Equipment Warranty Expiration",
  设备开始运行: "Equipment Start-up",
  签订维保合同: "Maintenance Contract Signed",
  维保服务开始: "Maintenance Service Started",
  维保服务到期: "Maintenance Service Expired",
  橙色预警: "Orange Warning",
  红色预警: "Red Warning",
  绿色预警: "Green Warning",
  数据丢失: "Data Loss",
  设备维修: "Equipment Repair",
  设备保养: "Equipment Maintenance",
  故障排除: "Troubleshooting",
  设备报废: "Equipment Decommissioning",
  下次保养: "Next Maintenance",
  请选择负责省份: "Please select the responsible province!",
  创建了一个新的请求: "created a new service request",
  请求: "Request",
  已被升级为工单: "has been escalated to work order",
  已完成: "has been completed",
  已被取消: "has been canceled",
  新的工单: "New work order",
  工单转派申请: "Work order reassignment request",
  工单已完成: "Work order completed",
  工单已关闭: "Work order closed",
  //工单编号{p1}-{p2}工程师已完成执行过程，请您查看检验并签字确认
  工单编号: "Work order number",
  工程师已完成执行过程: "the engineer has completed the execution process",
  请您查看检验并签字确认: "please review, inspect, and sign for confirmation",
  默认接受人: "Default recipient",
  默认联系人: "Default contact",
  资质证书上传: "Upload of qualification certificates",
  新增账号: "Add new account",
  KA客户类型: "KA Customer Type",
  总览: "Dashboard",
  云图: "Overview",
  设备云图: "Equipment Overview",
  工单: "Work Order",
  商机: "Business Opportunity",
  主页: "Home",
  能耗配置: "Energy Consumption Allocation",
  智能运维: "Intelligent Operations and Maintenance",
  健康监控: "Health Monitoring",
  事件管理: "Event Management",
  图谱分析: "Graphical Analysis",
  专家系统服务: "Expert System",
  销售服务工程师: "Sales Service Engineer",
  技术服务工程师: "Technical Service Engineer",
  服务回访导出: "Service Return Export",
  服务回访导入: "Import Service Callbacks",
  保存: "Save",
  智能诊断: "Intelligent Diagnosis",
  是否技改: "Upgrade status",
  历史电流导入: "Import historical current",
  历史电流数据导入: "Historical current data import",
  点击上传历史电流数据: "Click to upload historical current data",
  建议按照年度上传历史电流数据进行分析对比:
    "It is recommended to upload historical current data by year for analysis and comparison.",
  技改前数据请上传一个自然年数据:
    "Please upload a full calendar year of data for the Pre.",
  点击下载: "Click to download",
  技改前: "Pre",
  技改后: "Real",
  实际数据: "Actual Data",
  其他: "Other",
  模型: "Model",
  在此输入数据快照名称: "Enter the data snapshot name here",
  device_work_order: {
    贴二维码: "apply for QR code sticker.",
    设备维修: "apply for equipment maintenance.",
    设备保养: "apply for equipment servicing.",
    安装调试: "apply for installation and commissioning.",
    故障排除: "apply for troubleshooting.",
    延保服务: "apply for extended warranty service.",
  },
  大于200台: "More than 200",
  "100～200台": "100～200",
  小于100台: "Less than 100",
  查看设备: "View Device",
  北京: "Beijing",
  上海: "Shanghai",
  天津: "Tianjin",
  重庆: "Chongqing",
  河北: "Hebei",
  山西: "Shanxi",
  辽宁: "Liaoning",
  吉林: "Jilin",
  黑龙江: "Heilongjiang",
  浙江: "Zhejiang",
  福建: "Fujian",
  山东: "Shandong",
  河南: "Henan",
  湖北: "Hubei",
  湖南: "Hunan",
  广东: "Guangdong",
  海南: "Hainan",
  四川: "Sichuan",
  贵州: "Guizhou",
  云南: "Yunnan",
  江西: "Jiangxi",
  陕西: "Shaanxi",
  青海: "Qinghai",
  甘肃: "Gansu",
  广西: "Guangxi",
  新疆: "Xinjiang",
  内蒙古: "Inner Mongolia",
  西藏: "Tibet",
  宁夏: "Ningxia",
  台湾: "Taiwan",
  香港: "Hong Kong",
  澳门: "Macau",
  安徽: "Anhui",
  江苏: "Jiangsu",
  今年电耗: "This year",
  去年电耗: "Last year",
  今年: "This year",
  "佶缔纳士是您值得信赖的合作伙伴,了解我们的CARE服务,让您的设备保持高效稳定的运行,为您的生产经营保驾护航！":
    "NASH is your trusted partner. Explore our CARE services to keep your equipment running efficiently and reliably, safeguarding your production and operations!",
  service_request: "Service Request",
  更换轴承润滑脂: "Replace bearing grease",
  清理换热器: "Clean the heat exchanger",
  更换减速机润滑油: "Replace the decelerator lubricating oil",
  "仪表（真空、压力、温度、液位）检查（校核）":
    "Inspect (calibrate) instruments (vacuum, pressure, temperature, liquid level)",
  更换填料: "Replace the filler",
  联轴器对中检查: "Coupling alignment inspection",
  清理工作液管线滤网: "Clean the filter of the working fluid pipeline",
  电机更换润滑脂: "Replace motor grease",
  真空泵间隙检查并调整: "Inspect and adjust Vacuum pump clearance",
  保养内容: "Maintenance Content",
  轴承风险无: "No bearing risk",
  汽蚀风险无: "No erosion risk",
  search: "search",
  Auditing: "Auditing",
  download: "Download",
  延保服务: "Extended Warranty Service",
  提醒: "Notification",
  "本次检测健康，无气蚀风险，无轴承相关风险":
    "This inspection indicates good health with no cavitation or bearing-related risks.",
  轴承和泵体振动正常: "Bearing and pump body vibration is normal",
  无较大噪音: "No big noise",
  泵腔内无较大异响: "No big abnormal sounds in the pump chamber.",
  "设备运行环境良好，无灰尘、杂质等污染物进入轴承区域":
    "The operating environment is good, with no dust, impurities, or other pollutants entering the bearing area.",
  "请遵照佶缔纳士原厂使用说明书上的维护建议进行定期检修，维修设备健康和稳定高效的运行。":
    "Please follow the maintenance suggestions on the original instruction manual of the NASH original factory for regular maintenance, and the maintenance equipment is healthy, stable and efficient.",
  "泵运行平稳，没有异常噪音或振动":
    "The pump runs smoothly with no abnormal noise or vibration.",
  "液体流量和压力在正常范围内，没有出现剧烈波动":
    "Liquid flow and pressure are within the normal range, with no severe fluctuations.",
  "泵壳和叶轮表面无明显汽蚀损伤或腐蚀痕迹。":
    "There are no obvious cavitation damages or corrosion marks on the pump casing or impeller surface.",
  暂无风险: "No risk",
  device_event_description: {
    进入健康状态: "Get into a healthy state.",
    进入亚健康状态: "Enter an ailment.",
    进入异常状态: "Enter a sub-health state.",
  },
  故障说明: {
    轴承温度过高: "Bearing temperature too high",
    工作液温度过高: "Operating fluid temperature too high",
    换热器堵塞: "Heat exchanger blockage",
    建议拆除入口临时开车滤网:
      "Recommend removing the inlet temporary drive filter",
    "清洗板式换热器 检查循环冷却水系统":
      "Clean plate heat exchanger and inspect the circulatingcooling water system",
    "一线氢压机投氢气运行，提到满负荷后分离器液环波动大，最高从15cm至30cm。":
      "One-line hydrogen compressor is operating with hydrogen injection, and after reaching full load, the liquid ring in the separator shows significant fluctuations, ranging from 15 cm to 30 cm at the highest point.",
    "一线氢压机试车时非驱动端轴承温度高。":
      "One-line hydrogen compressor exhibits elevated non-drive end bearing temperature during the trial run.",
    叶轮叶片裂纹及断裂: "Impeller Blade Cracks and Fractures",
  },
  结垢: "Scaling",
  气蚀分析: "Cavitation",
  无法启动: "Unable to start",
  轴承故障: "Bearing Failure",
  泄漏: "Leak",
  真空度不足: "Insufficient Vacuum",
  真空泵NDE轴承水平振动: "Horizontal Vibration NDE Bearing",
  真空泵NDE轴承轴向振动: "Axial Vibration NDE Bearing",
  "t-menu": "Menu",
  root_sn_exists: "Duplicate pump head serial number, please re-enter！",
  group_sn_exists: "Duplicate unit serial number, please re-enter!",
  //706
  气蚀状态低风险预警: "Cavitation Medium",
  气蚀状态高风险预警: "Cavitation High",
  Login_Title: "ALUDYNE汽车零部件（南通）工厂DPLUS数字化生产平台",
  Remember_me: "Remember me",
  "Wait...": "Wait...",
  Login: "Login",
  username: "userName",
  password: "passWord",
  input: "Your {0}",
  err_msg: "Please enter the {0}",

  output: "output",
  Pro_Status: "Production Status",
  DTY_output: "TDY’s Output",
  TWD_output: "Output WTD",
  Die_casting: "Die Casting",
  Machining: "Machining",
  MTD_output: "Output MTD",
  Plan_Month_out: "Planned Output for This Month",
  Completion: "Completion%",
  Daily_Output_MTD: "Daily Output MTD",

  Customise_Dashboard: "Select Widgets",

  Takt_Time: "Cycle Time",
  Pro_takt_time: "Cycle Time",
  Target_val: "Tgt.Val.",
  Actual_val: "Act.Val.",
  Daily_Takt_Time_MTD: "Daily Cycle Time MTD (s)",

  Values_Per_Capita: "Values Per Capita",
  TDY_Output_Percap: "TDY’s Output Percap.",
  TDY_Defects_Percap: "TDY’s Defects Percap.",
  Output_Percap: "Output Percap.",
  Defects_Percap: "Defects Percap.",

  Monthly_Defects_Analysis: "Monthly Defects Analysis",

  Daily_Defects_Analysis: "Daily Defects Analysis",
  Defects_Quantity: "Defects Qty.",
  Defects: "Defects%",
  Case: "Case",
  Other: "Other",

  OEE: "OEE",
  Mthly: "Mthly",
  Wkly: "Wkly",
  Daily: "Daily",
  Vs_pre: "vs prev.",
  Month: "Month",
  Week: "Week",
  Day: "Day",
  Availability: "Availability",
  Performance: "Performance",
  Quality: "Quality",

  Equipment_Util: "Equipment Utilisation",
  Total_Machines: "Total No. of Machines",
  Working_Machines: "No. of Working Machines",
  Machine_Availability: "Machine Availability",

  Equipment_Unit: "Unit",
  Planned_Prod_Time: "Planned Prod. Time",
  Downtime: "Downtime",
  Outage: "Outage%",

  Production_Status: "Production Status",
  TDY_Planned_Output: "TDY’s Planned Output",
  TDY_Qualified_Output: "TDY’s Self-insp. Qualified Output",
  Output_WTD: "Output WTD",
  Output_MTD: "Output MTD",

  TDY_Completed_Work_Orders: "TDY’s Completed Work Orders",
  TDY_Completed_Work_Orders_List: "TDY’s Completed Work Orders List",
  Work_Order: "Work Order",
  Product: "Product",
  Output: "Output",
  Work_Order_Speed: "Progress",
  Start: "Start",
  End: "End",
  Unhealthy: "Unhealthy",
  Test_Num: "Total",

  TDY_Actual_Output: "TDY’s Actual Output",

  Machine_Info: "Machine Info",
  Machine_Name: "Machine Name",
  Machine_ID: "Machine ID",
  Machine_Model: "Machine Model",
  Manufacturer: "Manufacturer",
  Person_in_Charge: "Person in Charge",

  RealTime_Data_Monitoring: "Real-time Data Monitoring",
  Customise_Data: "Customise Data",
  Search_Name: "Search by data name ",
  selected_data: "{0} data selected, up to {1} data",

  Hourly_Output: "Hourly Output",
  TDY_Working_Hours: "TDY’s Working Hours",
  TDY_Hourly_Output: "TDY’s Hourly Output",

  Whole_Factory: "Whole Factory",
  Solid_Solution: "Solid Solution",
  Aging_Treatment: "Aging Treatment",

  Machining_Name: "{0}# Machining",

  Sure: "Confirm",
  Cancel: "Cancel",

  loading: "Loading data model, please be patient... already loaded {0}%",

  selectData: {
    Metal_Press: "Metal Press",
    User_Range: "User Avg Vel Range{0}",
    Biscuit_Size: "Biscuit Size",
    Aluminium_Tmp: "Aluminium Tmp",
    Cooling_Water_Tmp: "Cooling Water Tmp",
    DataPoint: "Data point {0}",
  },

  focusTitle: {
    Target_value: "Target Value",
    Actual_value: "Actual Value",
    DTY: "Today’s Output",
    WTD: "Output Week-to-date",
    MTD: "Output Month-to-date",
    Daily_output: "Daily Output Month-to-Date",
    Daily_CycleTime: "Daily Cycle Time Month-to-Date",
    Today_pre: "Today’s Output Per Capita",
    Monthly_OEE: "Monthly OEE",
    Weekly_OEE: "Weekly OEE",
    Daily_OEE: "Daily OEE",
    Output_Per_Capita: "Today’s Output Per Capita",
    Defects_Per_Capita: "Today’s Defects Per Capita",
    Defects_Qty: "Defects Quantity",

    Prod_Time: "Planned Production Time",
    Planned_Output: "Today’s Planned Output",
    Self_insp: "Today's Self-inspection Qualified Output",

    Completed_Work_Orders: "Today’s Completed Work Orders",
    Completed_Work_Orders_List: "Today’s Completed Work Orders List",

    Actual_Output: "Today’s Actual Output",

    Working_Hours: "Today’s Working Hours",
  },
  "IIoT maintenance management platform": "Maintenance Management Platform",
  "VSD420 dry screw vacuum pumping station":
    "VSD420 dry screw vacuum pumping station",
  "Negative Pressure Vacuum Unit": "Negative Pressure Vacuum Unit",
  "iV706 Intelligent Vacuum Unit": "iV706 Intelligent Vacuum Unit",
  "Unit Information": "Unit Information",
  "Equipment Name": "Equipment Name",
  "Equipment Serial No.": "Equipment Serial No.",
  "Equipment Type": "Equipment Type",
  "Suction flow": "Suction Flow",
  "Extreme Vacuum": "Extreme Vacuum",
  "Back pressure": "Back Pressure",
  "Equipment Alarm": "Equipment Alarm",
  "Equipment running time": "Equipment running time",
  Hint: "Hint",
  "Equipment Maintenance Plan": "Equipment Maintenance Plan",
  "Recent Events": "Recent Events",
  Notice: "Notice",
  Error: "Warning",
  Warning: "Caution",
  Normal_status: "In Operation",
  Caution_status: "Caution",
  Warning_status: "Warning",
  "Maintenance Service": "Maintenance Service",
  "Last Service Date": "Last Service Date",
  "Last Service Level": "Service Level",
  "Next Service Time": "Next Service Time",
  "Service Level": "Service Level",
  "Duration from last maintenance run": "Duration from last maintenance run",
  "Maintenance records": "Maintenance records",
  "Inlet temperature": "Temperature",
  "Inlet pressure": "Pressure",
  "Electric current": "Electric Current",
  "Suction Pressure": "Suction Pressure",
  "Screw pump motor": "Screw pump motor",
  "Screw pumps": "Screw Pumps",
  "Roots Pumps": "Roots Pumps",
  "Roots pump motor": "Roots Pump Motor",
  Current: "Current",
  Torque: "Torque",
  "Rotation Speed": "Rotation Speed",
  "Power consumption": "Power Consumption",
  "X-directional vibration": "X-directional Vibration",
  "Y-directional vibration": "Y-directional Vibration",
  "Cooling water temperature": "Cooling Water Temperature",
  "Cooling water flow": "Cooling Water Flow",
  "Station Current": "Whole Station Operating Current",
  "Station suction pressure": "Station Suction Pressure",
  "Unit Status": "Running Status",
  "Total running time of equipment": "Total Running Time of Equipments",
  "Last boot time": "Uptime",
  "Operation/stop of the whole station": "Run/Stop of the whole station",
  "Roots pump motor vibration": "Roots Pump Motor Vibration",
  "Roots pump vibration": "Roots Pump Vibration",
  "Screw pump motor vibration": "Screw Pump Motor Vibration",
  "Screw pump vibration": "Screw Pump Vibration",
  "High frequency vibration analysis": "High Frequency Vibration Analysis",
  "General view of equipment operation": "General View of Equipment Operation",
  "Energy consumption analysis": "Energy Consumption Analysis",
  "Intelligent Fault Prediction": "Intelligent Fault Prediction",
  "Data Simulation Model": "Data Simulation Model",
  "Equipment operation reference": "Operating Parameters",
  Parameters: "Parameters",
  Reference: "Reference",
  "Roots pump motor real-time rotational speed":
    "Roots Pump Motor Real-time Rotation Speed",
  "Roots pump motor real-time current": "Roots Pump Motor Real-time Current",
  "Roots pump inlet pressure": "Roots pump inlet pressure",
  "Screw pump motor real-time rotational speed":
    "Screw Pump Motor Real-time Rotational Speed",
  "Screw pump motor real-time current": "Screw Pump Motor Real-time Current",
  "Screw pump inlet pressure": "Screw Pump Inlet Pressure",
  "Diagnosis conclusion": "Diagnosic Advice",
  "Alarm number": "Ref. No.",
  "Fault Type": "Fault Classification",
  "Processing suggestions": "Advice",
  "Diagnosis time": "Time",
  "Diagnostic Report": "Diagnostic Report",
  "Roots pump motor non-drive end level":
    "Roots Pump Motor Non-drive End Horizontal",
  "Roots pump motor drive end level": "Roots Pump Motor Drive End Horizontal",
  "Screw pump motor non-driven end level":
    "Screw Pump Motor Non-driven End Horizontal",
  "Screw pump motor drive end level": "Screw Pump Motor Drive End Horizontal",
  "Roots pump non-drive end level": "Roots Pump Non-drive End Horizontal",
  "Roots pump drive end - horizontal direction":
    "Roots Pump Motor Side Horizontal Vibration",
  "Roots pump drive end - horizontal direction-title": "Horizontal Vibration",

  "Screw pump non-driven end level": "Screw Pump Non-driven End Horizontal",
  "Screw pump drive end level": "Screw Pump Drive End Horizontal",
  "Peak acceleration": "Peak Acceleration",
  "Speed RMS": "Speed RMS",
  "Trend graph": "(Trend Graph)",
  "Waveform graph": "(Waveform Graph)",
  "Horizontal-acceleration": "Acceleration",
  "Peak envelope": "Envelope Analysis",
  "Bearing Status": "Bearing Status",
  "Bearing temperature": "Bearing Temperature",
  "High Frequency Vibration Spectrum": "Vibration Spectrum",
  "Roots pump drive end - horizontal direction- effective value of speed (mm/s) (trend graph)":
    "Roots Pump Drive End - Horizontal Effective Value of Speed (mm/s) (Trend Graph)",
  "Horizontal-acceleration (m/s^2) at the driving end of the Roots pump (waveform graph)":
    "Horizontal Acceleration (m/s^2) at the Driving End of the Roots Pump (Waveform Graph)",
  "Roots pump drive end - horizontal direction-envelope (m/s^2) (waveform graph)":
    "Roots Pump Drive End - Horizontal Envelope (m/s^2) (Waveform Graph)",
  "Horizontal bearing temperature at the drive end of the Roots pump (°C)":
    "Horizontal Bearing Temperature at the Drive End of the Roots pump (°C)",
  "Vacuum pump station room": "Vacuum Pump Station Room",
  "Energy Efficiency Overview": "Energy Efficiency Overview",
  "Total electricity bill for the month":
    "Total Electricity Bill for Current Month",
  "Year-on-year": "Year-on-year",
  "link relative ratio": "Month-to-Month",
  "ten thousands": "Ten Thousand",
  Rmb: "CNY",
  Ton: "ton",
  "Rmb/Nm": "CNY/Nm³",
  "Monthly aspirated electricity consumption":
    "Monthly suction power consumption",
  "Monthly cumulative inhalation": "Monthly Air Suction Amount",
  "Monthly suction unit price": "Monthly Unit Price of Air Suction",
  "Monthly suction electricity price": "Monthly suction electricity price",
  "Total cumulative monthly electricity consumption":
    "Total Monthly Electricity Consumption",
  "Unit No. 2": "Unit No. 2",
  "Unit No. 1": "Unit No. 1",
  Shutdown: "Shutdown",
  Failure: "Failure",
  Run: "Run",
  "Monthly cumulative running time": "Monthly Cumulative Running Time",
  "22 days 9 hours": "22 days 9 hours",
  "Suction power consumption": "Electricity Consumption on Air Suction",
  "Suction unit price": "Unit Price of Air Suction",
  "Suction efficiency": "Efficiency of Air Suction",
  "Effective power": "Effective Electricity",
  "Power loss": "Power Loss",
  "Daily inspiratory electricity consumption":
    "Daily Electricity Consumption on Air Sunction",
  "August Energy Efficiency Details": "August Energy Efficiency Details",
  "Unit No. 1 suction power consumption":
    "Unit No. 1 Suction Power Consumption",
  "Vacuum station integrated suction power consumption":
    "Vacuum Station Integrated Suction Electricity Consumption",
  "Daily Inhalation": "Daily Inhalation",
  "Unit Aspiration": "Unit Aspiration",
  "Vacuum station suction": "Vacuum Station Suction",
  "Vacuum station integrated suction": "Vacuum Station Integrated Suction",
  "Daily electricity consumption": "Daily Electricity Consumption",
  "Current consumption of the unit": "Current Consumption of the Unit",
  "Vacuum power consumption": "Vacuum Power Consumption",
  "Monthly flat, valley and peak power consumption ratio":
    "Monthly Electricity Consumption Propotion on Peak, Valley and Usual Times",
  "Peak hour power consumption": "Peak hour power consumption",
  "Valley time electricity consumption": "Valley Time Electricity Consumption",
  "Usual electricity consumption": "Usual Electricity Consumption",
  "Monthly inhalation electricity bill":
    "Monthly Electricity Bill of Air Suction",
  "Usual electricity bill": "Usual Electricity Bill",
  "Peak hour electricity rates": "Peak Hour Electricity Rates",
  "Valley hour electricity rates": "Valley Hour Electricity Rates",
  "Total Aspiration Cost": "Total Aspiration Cost",
  "Aspiration cost": "Aspiration Cost",
  "Customized mode": "Customized Mode",
  "Constant pressure mode": "Constant Pressure Mode",
  "Quantitative mode": "Quantitative Mode",
  "System inlet pressure": "System Inlet Pressure",
  "System inlet temperature": "System Inlet Temperature",
  "System entrance traffic": "System Entrance Traffic",
  "System outlet pressure": "System Outlet Pressure",
  "Roots pump motor X-axis vibration": "Roots Pump Motor X-axis Vibration",
  "Screw pump motor X-axis vibration": "Screw Pump Motor X-axis Vibration",
  "Principle Description": "Principle Description",
  "Schematic diagram of neurons": "Schematic Diagram of Neurons",
  "Hidden layer activation function": "Activation Function of Hidden Layer",
  "Each neuron is connected to all neurons in the previous layer of the neural network layer. An n-dimensional vector space is divided into two parts with a hyperplane using a judgment boundary, and given an input vector, a scalar result is obtained by passing the activation function after finding the inner product of the input vector and the weight vector. The composite neural network combined by multilayer neurons connects multiple models in series during the transfer of process parameter relations to realize the digital simulation of the whole process.":
    "Each neuron is connected to all neurons in the previous layer of the neural network layer. An n-dimensional vector space is divided into two parts with a hyperplane using a judgment boundary, and given an input vector, a scalar result is obtained by passing the activation function after finding the inner product of the input vector and the weight vector. The composite neural network combined by multilayer neurons connects multiple models in series during the transfer of process parameter relations to realize the digital simulation of the whole process.",
  "Total operating hours of the equipment":
    "Total Operating Hours of the Equipment",
  "Last start time": "Uptime",
  "Whole station run/stop": "Whole Station Run/Stop",
  "Screw motor": "Screw Motor",
  "Roots motor": "Roots Motor",
  "Normal operation": "Normal",
  "Negative pressure vacuum unit": "Negative Pressure Vacuum Unit",
  "Water replenishment solenoid valve": "Water Replenishment Solenoid Valve",
  "Cooling fans": "Cooling fans",
  "Centrifugal pump operating status": "Operating Status of Centrifugal Pump",
  "Intelligent pump remote control / local":
    "Intelligent Pump Remote Control / Local",
  "Intelligent pump emergency stop": "Intelligent Pump Emergency Stop",
  "Liquid level": "Liquid level",
  "Working water inlet temperature": "Working Water Inlet Temperature",
  "Temperature inside the chassis": "Temperature inside the Chassis",
  "Vacuum system inlet pressure": "Vacuum System Inlet Pressure",
  "Motor current": "Motor Current",
  "Working fluid temperature": "Working Fluid Temperature",
  "Fan operation status": "Fan Operation Status",
  "Centrifugal pump run/stop": "Centrifugal Pump Run/Stop",
  "Centrifugal pump ready/failure": "Centrifugal Pump Ready/Failure",
  "Water ring vacuum pump running/stopping": "Water Ring Vacuum Pump Run/Stop",
  "Water ring vacuum pump ready/failure":
    "Water Ring Vacuum Pump Ready/Failure",
  "Vacuum pump inlet valve": "Vacuum Pump Inlet Valve",
  "Data Streaming": "Data Streaming",
  "View Details": "View Details",
  "Vibration Charts": "Vibration Charts",
  "Vacuum pump non-driving end bearing vibration":
    "Vacuum Pump Non-driving End Bearing Vibration",
  "Vacuum pump drive end bearing vibration":
    "Vacuum Pump Drive End Bearing Vibration",
  "Vacuum unit current curve": "Real-time Current ",
  "Vacuum unit current": "Real-time Current ",
  "Pump Bearing Vibration": "Pump Bearing Vibration (mm/s)",
  "Vacuum unit inlet pressure curve": "Vacuum Unit Inlet Pressure ",
  "Vacuum unit inlet pressure": "Vacuum Unit Inlet Pressure",
  "Heat exchanger temperature profile": "Heat Exchanger Temperature Profile",
  "Working fluid inlet": "Working Fluid Inlet",
  "Working fluid outlet": "Working Fluid Outlet",
  "Cooling water inlet": "Cooling Water Inlet",
  "Cooling water outlet": "Cooling Water Outlet",
  "Remote control": "Remote Control",
  "Heat exchanger temperature curve": "Heat Exchanger Temperature",
  "Energy saving overview": "Unit Annual Energy Saving Overview",
  "Total annual energy unit": "Total Annual Energy Saving Benefit",
  "UN power saving income": "Annual Electricity Saving Benifit",
  "UN CO2 emission benefit": "Annual CO₂ Saving Benifit",
  "Predictive maint saves benefits": "Annual Predictive Maintenance Saving",
  "Total power saving": "Total power saving",
  "Reduced CO2 emissions": "Reduced CO₂ emissions",
  "CO2 price today": "Present CO₂ Price",
  "Electricity price today": "Present Electricity Price",
  "Coal price today": "Coal price today",
  "UN energy saving analysis": "Unit Energy Saving Analysis",
  "UN energy saving chart": "Last 30 days Electricity Saving Chart",
  "Savings on electricity 30d": "Last 30 days Electricity Saving Benefit",
  "CO2 emissions reduced 30d": "Last 30 days CO₂ Saving Benifit",
  "Electricity bill 30d": "Last 30 days Electricity Costs",
  "CO2 emissions 30d": "Last 30 days CO₂ Costs",
  "Monthly electricity": "Monthly electricity consumption analysis",
  "UN monitoring and analysis":
    "Real-time energy consumption monitoring and analysis of units",
  "Operating status": "Operating status",
  "Energy saving": "Energy Saving",
  "SA energy saving benefit":
    "Annual total income from energy saving and efficiency enhancement",
  "SA coal saving income": "Annual Coal Saving",
  "SA CO2 emission benefit": "Annual CO₂ Saving",
  "Power before renovation": "Power consumption before renovation",
  "Power after renovation": "Power consumption after renovation",
  "Actual power": "Actual electricity consumption",
  "Rated power": "Rated electricity consumption",
  "Roots pump motor rated power": "Roots pump motor rated power",
  "Screw pump motor rated power": "Screw pump motor rated power",
  "Total coal saving": "Total coal saving",
  "system_back_pressure_improves_cs": "Back pressure improvement coal saving",
  "unit_electricity_consumption_improvement_and_coal_savings_benefits":"Unit electricity consumption improvement and coal savings benefits",
  "Unit frequency conversion CS income":
    "Unit frequency conversion coal saving",
  "Unit Load Tracking CS Benefit": "Dyamic load following coal saving",
  "Risk Assessment Model": "Risk Assessment Model",
  "362 Days 20 Hours": "362 Days 20 Hours",
  "Last Service Record": "Last Service Record",
  "Level-1": "Level-1",
  Good_status: "Health",
  Enabled_status: "Enabled",
  "Smart O&M Model": "Smart O&M Mode",
  "Vacuum Running Status": "Vacuum Running Status",
  "Cavitation Analysis": "Cavitation Analysis",
  "NASH Store": "NASH Store",
  "Replace coupling resilient blocks": "Replace coupling resilient blocks",
  "Change motor lube oil": "Change motor lube oil",
  "Pump surface inspection": "Pump surface inspection",
  "Synchronous gears surface inspection":
    "Synchronous gears surface inspection",
  "Pump inlet filter inspection": "Pump inlet filter inspection",
  "Replace motor bearing": "Change motor bearing",
  Symptoms: "Symptoms",
  "Screw pump torque abnormal": "Screw pump torque abnormal",
  "Screw pump motor current abnormal": "Screw pump motor current abnormal",
  "Root cause analysis": "Root cause analysis",
  "Startup warmingup process missing": "Startup warmingup process missing",
  "Shutdown clearning and nitrogen purge replacement process missing":
    "Shutdown clearning and nitrogen purge replacement process missing",
  "Low cooling water temperature cause crystallistation":
    "Low cooling water temperature cause crystallistation",
  "Foreign object entry": "Foreign object entry",
  Advice: "Advice",
  "Check for rattling": "Check for rattling",
  "Lowering running speed": "Lowering running speed",
  "Open solvent cleaning": "Open solvent cleaning",
  "Increasing cooling water temperature":
    "Increasing cooling water temperature",
  "Roots pump motor current abnormal": "Roots pump motor current abnormal.",
  "Motor current abnormal": "Motor current abnormal.",
  "Roots pump motor pump overheating": "Roots pump motor pump overheating.",
  "Motor pump overheating": "Motor pump overheating.",
  "Roots pump motor vibration abnormal": "Roots pump motor vibration abnormal.",
  "Motor vibration abnormal": "Motor vibration abnormal.",
  "Machine Cleaning": "Machine Cleaning",
  Warmingup: "Warmingup",
  Maintenance: "Maintenance",
  "Stream media": "Stream media",
  "Roots pump inlet temperature": "Roots pump inlet temperature",
  "Confirm whether it is back to normal, otherwise stop and perform endoscopy":
    "Confirm whether it is back to normal, otherwise stop and perform endoscopy",
  "Torque  of screw pump is in the high-risk zone":
    "Torque  of screw pump is in the high-risk zone",
  "The motor current  of screw pump is in the high-risk zone":
    "The motor current  of screw pump is in the high-risk zone",
  "The outlet temperature  of screw pump is in the high-risk zone":
    "The outlet temperature  of screw pump is in the high-risk zone",
  "The outlet pressure   of screw pump is in the high-risk zone":
    "The outlet pressure   of screw pump is in the high-risk zone",
  "Pump Stuck Warning": "Pump seizure Warning",
  "Pump Stuck Caution": "Pump seizure Caution",
  "Gears or bearings Damaged": "Gears or bearings Damaged",
  "Not enough lubrication": "Not enough lubrication",
  "REC. Change greases": "REC. Change greases",
  "Overheating of the pump body": "Overheating of the pump body",
  "High temperature of inlet gases": "High temperature of inlet gases",
  "Lower inlet gas temperature": "Lower inlet gas temperature",
  "Cooling water flow of the Roots pump is not less than the minimum flow":
    "Cooling water flow of the Roots pump is not less than the minimum flow",
  "Inlet temperature-sim": "Inlet Temperature",
  "Entrance Flow-sim": "Entrance Flow",
  "Motor Current of Roots Pump": "Motor Current of Roots Pump",
  "Inlet Flow Rate of Screw Pump": "Inlet Flow Rate of Screw Pump",
  "Inlet Pressure of Screw Pump": "Inlet Pressure of Screw Pump",
  "Motor Current of Screw Pump": "Motor Current of Screw Pump",
  "rpm of Motor of Roots Pump": "Motor rpm of Roots Pump",
  "Motor X-axis Vibration of Roots Pump":
    "Motor X-axis Vibration of Roots Pump",
  "Motor X-axis Vibration of Screw Pump":
    "Motor X-axis Vibration of Screw Pump",
  "Motor rpm of Screw Pump": "Motor rpm of Screw Pump",
  "Instrument Calibration": "Instrument calibration",
  "Analysis of Online": "Online Analysis",
  "Parts Purchase": "Parts Purchase",
  "Pump seizure": "Pump seizure",
  "Motor loads": "Motor loads",
  "Pump Noises": "Pump noises",
  "Select Part No": "Select Part No.",
  Analysing: "Analysing",
  Finished: "Finished",
  "Online Service": "Online Service",
  "Unit Real-time Operation Data": "Unit Real-time Operation Data",
  "Drive Side": "Drive Side",
  "Non-drive Side": "Non-drive Side",
  "Motor Overloaded": "Motor Overloaded",
  "Motor high vibration detected": "Motor high vibration detected",
  "Troubleshooting according to the above root causes.If the motor viration continues to increase it is recommended to switch to the backup unit":
    "Troubleshooting according to the above root causes.If the motor viration continues to increase it is recommended to switch to the backup unit",
  "Bearing failure": "Bearing failure",
  "Exhaust valve plate dislodged": "Exhaust valve plate dislodged",
  "Foreign objects in pump body": "Foreign objects in pump body",
  "Loose ground bolts": "Loose ground bolts",
  "Pump fouling": "Pump fouling",
  Cavitation: "Cavitation",
  "Coupling alignment": "Coupling alignment",
  "Steam temperature": "Steam temperature",
  "V Inlet pressure": "Inlet pressure",
  "Cold air": "Cold air",
  "Motor side bearing viberation": "Motor side bearing viberation",
  "Pump side bearing viberation": "Pump side bearing viberation",
  "Enivornment temperature": "Enivornment temperature",
  "Env Pressure": "Env Pressure",
  "Inlet Pressure": "Inlet Pressure",
  "Steam Temperature": "Steam Temperature",
  "Air Subcooling": "Air Subcooling",
  "Mixed Air Temperature": "Mixed Air Temperature",
  "Working Flow Temperature": "Working Flow Temperature",
  "Steam temperature-v": "Steam Temperature",
  "V-Inlet pressure": "Inlet Pressure",
  "Cavitation Warning": "Cavitation Warning",
  "Cavitation Caution": "Cavitation Caution",
  "Pump pressure difference is too high":
    "Pump pressure difference is too high",
  "Heat exchanger tubes blocked": "Heat exchanger tubes blocked",
  "Low working fluid flow": "Low working fluid flow",
  "Low separator level": "Low separator level",
  "Inlet filter blocked": "Inlet filter blocked",
  "Inlet check valve blocked": "Inlet check valve blocked",
  "Troubleshooting according to above listed root causes, if cavitation remain it is recommended to switch to the back machine":
    "Troubleshooting according to above listed root causes, if cavitation remain it is recommended to switch to the back machine",
  "Check if the heat exchanger tubes blocked, if working fluid flow rate is low, check orifice plate blocked":
    "Check if the heat exchanger tubes blocked, if working fluid flow rate is low, check orifice plate blocked",
  "Check if inlet filter is blocked, if the separator level is also low, you need to check the water fill solenoid valve":
    "Check if inlet filter is blocked, if the separator level is also low, you need to check the water fill solenoid valve",
  "Water Consumption Analysis": "Water Consumption Analysis",
  "Water Consumption Caution": "Water Consumption Caution",
  "Water Consumption Warning": "Water Consumption Warning",
  "High bearing vibration": "High bearing vibration",
  "Check for coupling alignment": "Check for coupling alignment",
  "Check for pump cavitation": "heck for pump cavitation",
  "Check for fouling in pumps": "Check for fouling in pumps",
  "Check for foreign object in pump": "Check for foreign object in pump",
  "Check for dislodged exhaust valves": "Check for dislodged exhaust valves",
  "Filling bearing greases": "Filling bearing greases",
  "Change bearing greases": "Change bearing greases",
  "Filling motor bearing greases": "Filling motor bearing greases",
  "Filler replacement": "Filler replacement",
  "Replace coupling diaphragm": "Replace coupling diaphragm",
  "Cleaning heat exchanger": "Cleaning heat exchanger",
  "Replace bearing": "Replace bearing",
  "Change motor bearing greases": "Change motor bearing greases",
  Off: "Off",
  "Emergency stop": "Emergency stop",
  Normal: "Normal",
  High: "High",
  Low: "Low",
  "Running Current": "Current",
  "Running time": "Running Time",
  expert_view: "Expert View",
  intelligent_diagnose: "Intelligent Diagnose",
  audit_report: "Audit Report",
  energy_consumption_analysis: "Energy Consumption Analysis",
  energy_analysis: "Energy Anlaysis",
  device_lifecycle: "Lifecycle",
  online_store: "Nash Online Store",
  all_device: "All Device",
  digital_twin: "Digital Twin",
  industry: "Industry",
  customer_name: "Customer",
  cooling_water_temp: "Cooling Water Temp",
  suction_pressure: "Suction Pressure",
  rotation_speed: "Rotation Speed",
  gas_displacement: "Gas Displacement",
  heat_exchange_ttd: "Heat Exchange TTD",
  power_consumption: "Shaft Power",
  Apply: "Apply",
  设备数据: "Device Data",
  建议进行IOT升级: "An IOT upgrade is recommended",
  设备事件: "Device Events",
  设备工单: "Device Work Order",
  month: {
    jan: "Jan.",
    feb: "Feb.",
    mar: "Mar.",
    apr: "Apr.",
    may: "May",
    jun: "Jun.",
    jul: "Jul.",
    aug: "Aug.",
    sep: "Sep.",
    oct: "Oct.",
    nov: "Nov.",
    dec: "Dec.",
  },

  overview_dynamic: {
    新增: "New",
    报废: "Retired",
    在用: "All Alive",
    设备数量统计: "Device Amount Trend",
    IoT状态统计: "IoT Status Trend",
    //work order type
    设备维修: "Repair",
    点巡检: "Auditing",
    安装调试: "Installation",
    故障排查: "Troubleshooting",
    设备保养: "Service",
    工单负荷: "Workload",
    //商机丢失原因类型
    现场无此设备: "Device not Alive",
    客户自行维护: "Customer Self-Maintenance",
    第三方: "by Third Party",
    零部件供应商: "by Vendor",
    竞争对手: "by Competitor",
    其它: "Others",

    //设备类型
    device_type_dict: {
      液环泵: "Liquid Ring Pump",
      罗茨泵: "Roots Pumps",
      螺杆泵: "Dry Screw Pumps",
      风机: "Air Blower",
      干泵: "Dry Pump",
      其他: "Other",
    },

    //行业类型 “|” 在 vue-i18n 中属于特殊字符（还有{、}、@ 、$），如果要使用的话必须通过插值表达式 {'|'}，比如：“多个参数请使用{'|'}连接”。
    industy_dict: {
      制药: "Pharma",
      石化: "Petrochem",
      造纸: "Paper",
      化工: "Chem",
      通用: "General",
      油气: "O&G",
      设备: "Equip.",
      钢铁: "Steel & Iron",
      电力: "Elec.",
      污水: "Wastewater",
      矿业: "Mining",
      食品: "Food",
      造纸配套户: "Paper Ancil.",
      电子: "Electronics",
      核电: "Nuc.",
      啤酒: "Brewing",
      纤维: "Fibers",
      医疗: "Medical",
      有机硅: "Org.Silicon",
      煤化工: "Coal Chemicals",
      煤炭: "Coal",
      氨纶: "Spandex",
      烟草: "Tobacco",
      配套: "Supporting Services",
      煤矿: "Coal Mining",
      制糖: "Sugar Production",
      酵母: "Yeast",
      粮油: "Grain and Oil",
      医药: "Pharmaceuticals",
      轮胎: "Tires",
      炭黑: "Carbon Black",
      铝业: "Aluminum Industry",
      市政: "Municipal Services",
      铸造: "Casting",
      曝气: "Aeration",
      垃圾填埋: "Landfill",
      中央真空: "Central Vacuum",
      空气助燃: "Air-Assisted Combustion",
      总包: "General Contracting",
      蒸发: "Evaporation",
      家禽内脏剔除: "Removal of Poultry Viscera",
      浮选: "Floatation",
      烟气脱硫: "Flue Gas Desulfurization Systems",
      干燥: "Drying",
      包装: "Packaging",
      塑料挤出: "Plastic Extrusion",
      气力输送: "Pneumatic Conveying",
      食物: "Food",
      陶瓷: "Ceramics",
      分销商: "Distributor",
      过滤: "Filtration",
      OEM配套: "OEM Supply",
      金属生产: "Metal Production",
      采矿: "Mining",
      贸易公司: "Trading Company",
      水处理: "Water Treatment",
      OEM制造商: "OEM Manufacturer",
      造纸厂: "Pressure Zone Dewatering",//造纸厂，自定义为压区脱水
      纸浆厂: "Pulp Mill",
      卫生纸: "Toilet Paper",
      箱板纸: "Cartonboard Paper",
      原纸加工: "Raw Paper Processing",
      辅助苛化器: "Auxiliary Causticizer",
      无防布: "Non-woven Fabric",
      生物气处理: "Biogas Treatment",
      火炬气回收: "Torch Gas Recovery",
      Wais火炬气回收: "Wais Torch Gas Recovery",
      碳氢化合物: "Hydrocarbons",
      液化天然气: "Liquefied Natural Gas",
      VRU装卸: "VRU Loading and Unloading",
      废气: "Waste Gas",
      VRU储罐: "VRU Tank",
      VCG: "VCG",
      VDU: "VDU",
      VOC挥发性有机物: " VOC",
      油气其他: "Oil & Gas Others",
      污水处理厂市政曝气: "WWTP Municipal Exh",
      城市污水处理: "Urban WWTP",
      污水处理厂工业曝气: "WWTP Industrial Exh",
      污水处理厂工业消化池: "WWTP Industrial Dig",
      凝汽器抽真空: "Condenser Exhauster Systems",
      凝汽器启动抽空: "Condenser Start Vac",
      飞灰输送: "Fly Ash Handling Systems",
      地热发电: "Geothermal Power ",
      动力润滑油脱气: "Power Lubricating Oil Dehydration",
      水室真空泵: "Water Cavity Vac Pump",
      汽轮机: "Steam Turbine",
      填埋气压缩: "Landfill Gas Comp",
      氯气: "Cl2",
      VCM: "VCM",
      "TDI/MDI/HDI": "TDI/MDI/HDI",
      MMA: "MMA",
      PC: "PC ",
      PTMEG: "PTMEG",
      甲醇: "Methanol",
      "农药|蒸馏": "Pesticides {'|'} Distillation",
      "农用化学品|干燥": "Agri Chem {'|'} Dry",
      "农用化学品|反应器真空": "Agri Chem {'|'} Reactor Vac",
      "农用化学品|脱气": "Agri Chem {'|'} Dehyd",
      "农药|溶剂回收": "Pest {'|'} Solv Recov",
      "农药|结晶": "Pest {'|'} Cryst",
      "农药|过滤": "Pest {'|'} Filtr",
      "农药|蒸发": "Pest {'|'} Evap",
      "农药|冷冻干燥": "Pest {'|'} Fdry",
      特色香精蒸馏: "Spec Frag {'|'} Distil",
      "香精和香料|干燥": "Frag/Flavor {'|'} Dry",
      香精香料反应器真空: "Frag/Flavor {'|'} Reactor Vac",
      "香料|脱气": "Flavor {'|'} Dehydr",
      特种香精香料溶剂回收: "Spec Frag/Flavor {'|'} Solv Recov",
      "香料|结晶": "Flavor {'|'} Crys",
      "香精和香料|过滤": "Frag/Flavor {'|'} Filtr",
      "香料|蒸发": "Flavor {'|'} Evap",
      "香精香料|冷冻干燥": "Frag/Flavor {'|'} Fdry",
      "塑料、合成橡胶、树脂、纤维|蒸馏": "PSRRF {'|'} Distill",
      "塑料、合成橡胶、树脂、纤维|干燥": "PSRRF {'|'} Dry",
      "塑料、合成橡胶、树脂、纤维|反应器真空": "PSRRF  {'|'} Reactor Vac",
      "塑料、合成橡胶、树脂、纤维|脱气": "PSRRF {'|'} Dehyd",
      "塑料、合成橡胶、树脂、纤维|溶剂回收": "PSRRF {'|'} Solv Rec",
      "塑料、合成橡胶、树脂、纤维|结晶": "PSRRF {'|'} Cryst",
      "塑料、合成橡胶、树脂、纤维|过滤": "PSRRF {'|'} Filtr",
      "塑料、合成橡胶、树脂、纤维|蒸发": "PSRRF {'|'} Evap",
      "塑料、合成橡胶、树脂、纤维|冷冻干燥": "PSRRF {'|'} Fdry",
      "粘合剂和密封剂|蒸馏": "A&S {'|'} Distill",
      "粘合剂和密封剂|干燥": "A&S {'|'} Dry",
      "粘合剂和密封剂|反应器真空": "A&S {'|'} Reactor Vac",
      "粘合剂和密封剂|脱气": "A&S {'|'} Dehyd",
      "粘合剂和密封剂|溶剂回收": "A&S {'|'} Solv Rec",
      "粘合剂和密封剂|结晶": "A&S {'|'} Cryst",
      "粘合剂和密封剂|过滤": "A&S {'|'} Filtr",
      "粘合剂和密封剂|蒸发": "A&S {'|'} Evap",
      "粘合剂和密封剂|冷冻干燥": "A&S {'|'} Fdry",
      "油漆、清漆、清漆|蒸馏": "PVC {'|'} Dist",
      "油漆、清漆、清漆|干燥": "PVC {'|'} Dry",
      "涂料、清漆、清漆|反应器真空": "Coat {'|'} React Vac",
      "油漆、清漆、清漆|脱气": "PVC {'|'} Dist",
      "油漆、清漆、清漆|溶剂回收": "PVC {'|'} Solv Rec",
      "色漆、清漆、清漆|结晶": "PVC {'|'} Cryst",
      "油漆、清漆、清漆|过滤": "PVC {'|'} Filtr",
      "油漆、清漆、清漆|蒸发": "PVC {'|'} Evap",
      "油漆、清漆、清漆|冷冻干燥": "PVC {'|'} Fdry",
      "工业气体|氢气": "IndGas {'|'} H2",
      "工业气体|二氧化碳": "IndGas {'|'} CO2",
      "其他特种化学品及中间体|蒸馏": "Other Chem {'|'} Dist",
      "其他专业化学品和中间体|干燥": "Other Chem {'|'} Dry",
      "其他专业化学品和中间体|反应器真空": "Other Chem {'|'} React Vac",
      "其他特种化学品及中间体|脱气": "Other Chem {'|'} Dehyd",
      "其他特种化学品及中间体|溶剂回收": "Other Chem {'|'} Solv Rec",
      "其他特种化学品及中间体|结晶": "Other Chem {'|'} Cryst",
      "其他特种化学品和中间体|过滤": "Other Chem {'|'} Filtr",
      "其他特种化学品及中间体|蒸发": "Other Chem {'|'} Evap",
      "其他专业化学品和中间体|冷冻干燥": "Other Chem {'|'} Fdry",
      制药蒸馏: "Pharma Dist",
      药品干燥: "Pharma Dry",
      制药反应器真空: "Pharma React Vac",
      "制药|脱气": "Pharma {'|'} Dehyd",
      医药溶剂回收: "Med Solv Rec",
      药物结晶: "Med Cryst",
      制药过滤: "Pharma Filtr",
      药物蒸发: "Med Evap",
      冷冻干燥: "Fdry",
      臭氧: "Ozone",
      生物燃料: "Bio Fuel",
      "Carbon black": "Carbon black",
      General: "General",
    },

    //工单类型
    order_type_dict: {
      设备维修: "Repair",
      设备保养: "Service",
      安装调试: "Installation",
      故障排除: "T/S",
    },

    //工单状态
    order_status_dict: {
      已完成: "Completed",
      已取消: "Cancelled",
      施工中: "Under Construction",
      待施工: "Pending Construction",
      待转派: "Pending Reassignment",
      待确认: "Pending Confirmation",
      待派工: "Worker to be assigned",
    },

    //报告类型
    report_dict: {
      服务报告: "Service Report",
      回访报告: "Return Vist Report",
      开箱验收报告: "Out-of-box  Acceptance Report",
      现场培训: "On-site Training",
      维修报告: "Maintenance Report",
      安装调试报告: "Equipment Commissioning Report",
    },

    //保养类型
    service_type_dict: {
      日常保养: "Routine Maint.",
      一级保养: "L1 Maint.",
      二级保养: "L2  Maint.",
      返厂大修: "Factory OH",
    },

    //事件类型
    event_type_dict: { 提醒: "Notification", 错误: "Error", 警告: "Warning" },

    //智能运维模式
    smart_maintenance_dict: { 开启: "ON", 关闭: "OFF" },

    //IoT测点名称、事件信息以及保养详情没有翻译

    在保: "Warranty Valid",
    脱保: "Warranty Expired",
    离线: "Offline",
    请进行IoT升级: "Upgrade IoT",
    主页: "Home",
  },

  //数据统计页面上的静态信息（非接口返回）
  overview_static: {
    现场无此设备: "Equipment no alive",
    预测偏差: "Prediction Bias",
    竞争对手: "By Competitor",
    供应商直供: "By Vendor",
    找第三方: "By Third Party",
    客户自行维保: "Customer Self-Maintenance",
    //标题
    nash_intelligent_iiot_after_market_management_system:
      "Nash Intelligent IIoT Equipment Management System",
    //Menu
    overview: "Overview",
    dashboard: "Dashboard",
    business_opportunity: "Business Opportunity",
    work_order: "Work Order",
    device: "Device",

    //通用翻译
    common: {
      industry: "Industry",
      time: "Time",
      to: "to", //时间组件的from to
      work_order: "Work Order",
      customer: "Customer",
      device: "Device",
      amount: "",
      台: "", //英文没有量词，所以不翻译
      单: "",
      分: "",
      个: "",
      星期一: "Monday",
      星期二: "Tuesday",
      星期三: "Wednesday",
      星期四: "Thursday",
      星期五: "Friday",
      星期六: "Saturday",
      星期日: "Sunday",
      device_types: {
        liquid_ring_vacuum_pump: "Liquid Ring Vacuum Pump",
        roots: "Roots Pumps",
        screw_pump: "Dry Screw Vacuum Pumps",
        air_blower: "Air Blower",
      },
      details: "View Details",
    },

    //总览统计界面(左右上下)
    dahsboard_page: {
      //行业统计
      industry_overview: "Industry Overview",

      //设备状态
      device_status: "IoT Status",
      non_iot_device: "Non-IoT Device",
      iot_reday: "IoT Ready",
      iot_connected: "IoT Connected",
      other_status: "Other Status", //设备其他状态，非iot
      barcode_attached: "Barcode Attached    ", //已绑定
      barcode_unattached: "Barcode Unattached",
      wasted: "Wasted                  ",
      //弹窗信息
      进行中工单总量: "Ongoing Work Orders",
      //产品类型
      device_distribution_on_category: "Distribution on Category",

      //服务与商机
      business_opportunity: "Business Opportunity(BO)",
      bo_varivance_rate: "BO Varivance Rate",
      total_bo: "Total BO",
      hit: "Hit", //已完成
      to_be_converted: "to Be Converted",
      converted: "Converted",
      among_delayed: "among Delayed",

      //商机丢失原因
      varivace_reason: "Varivance Reason",
      总计延期量: "All Delayed",
      //工单统计
      work_order: "Work Order",
      responsed_on_time: "Responsed \non Time", //及时确认率
      closed_on_time: "Closed on\n Time", //及时关闭率
      done: "Done",
      customer_satisfaction: "Satis. Rate", //满意度
      customer_satisfaction_score: "Customer Satisfaction Score",

      map_area: {
        //齿轮图标
        barcode_attached: "Barcode Attached", //已绑定
        barcode_unattached: "Barcode Unattached",
        wasted: "Wasted",
        work_order_in_progress: "Work Order in Progress",
        work_order_amount: "Work Order Amount",
        customer_amount: "Customer Amount",

        healthy: "Healthy",
        abnormal: "Abnormal",
        risky: "Risky",
        non_iot_device: "Non-IoT Device",
        iot_reday: "IoT Ready",
        iot_connected: "IoT Connected",

        //服务图标
        order_amount: "Order Amount",
        order_in_progress: "Order in Progress",
        order_completed: "Order Completed",
        bo_amount: "BO Amount",
        workload: "Workload",
        设备数量: "Device Amount",
        服务数量: "Service Amount",
      },
    },

    //工单统计界面（左右上下）
    work_order_page: {
      details: "Detail",

      //第一行
      work_order_amount: "Work Order Amount",
      order_in_progress: "Order in Progress",
      compared_to_last_year: "compared to last year",
      order_in_this_month: "Order in this Month",
      compared_to_last_month: "compared to last month",
      month_by_month: "Month-by-Month",
      month_on_month: "Month-on-Month",
      completed_in_this_month: "Completed in this Month",

      //第二行
      order_status: "Work Order Stauts",
      order_trend: "Work Order Trend", //状态分析
      new_orders: "New Orders",
      complete_orders: "Complete Orders",
      incomplete_order: "Incomplete Order",
      unit: "Amount", //单
      report_distribution_on_category: "Distribution on Category",

      //第三行
      order_feedback: "Work Order Feedback",
      ave_response_speed: "Ave. Response Speed",
      response_to_arr: "Response to Arrive",
      ave_fix: "Average Time to Fix",
      customer_satisfaction_score: "Customer Satisfaction Score",
      responsed_on_time: "Responsed on Time", //及时确认率
      closed_on_time: "Closed on Time", //及时关闭率
      done: "Done",
      customer_satisfaction: "Satis. Rate", //满意度
      order_distribution_on_industry: "Order Distribution on Industry",
      order_amount: "Order Amount",
      单: "Amount",
    },

    //设备统计界面（左右上下）
    device_overview_page: {
      details: "Detail",

      //第一行
      device_amount: "Device Amount",
      台: "",
      compared_to_last_year: "compared to last year",
      increase_rate: "yearly increase rate",
      waste_reate: "yearly wasted rate",
      iot_reday: "IoT Ready",
      iot_connected: "IoT Connected",
      占所有设备量比: "Proportion of Device Amount",

      //第二行
      device_distribution_on_industry: "Distribution on Industry",
      greater_than: "Greater than",
      less_than: "Less than",
      device_category: "Device Category",

      //第三行
      main_category_distribtion_on_industry:
        "Main Category Distribution on Industry",
      new_device: "New Device",
      台y: "Amount",
      barcode_attached: "Barcode Attached", //已绑定
      barcode_unattached: "Barcode Unattached",
      unattached_among_all: "Unattache among All",
    },

    //客户统计界面（左右）
    customer_page: {
      serial_numner: "Serial Number",
      status: "Health Status",
      service_plan: "Service Plan",
      next_service_time: "Next Service Time",
      next_service: "Next Service",
      delayed: "Delayed", //23 days delayed
      天: "day(s)",
      service_status: "Service Status",
      warranty_valid_until: "Warranty Valid until",
      extend_your_warranty: "Extend your Warranty",
      device_events: "Device Events",
      iot_status: "IoT Status",
      health_status: "Health Status",

      online: "Online",
      offline: "Offline",
      healthy: "Healthy",
      abnormal: "Abnormal",
      risky: "Risky",
      unknown: "Unknown",
      energy_consumption_trend: "Energy Consumption Trend",
      device_consumption: "Device Consumption",
      benchmark: "Benchmark", //行业均值
    },

    //单个设备界面
    device_page: {
      //设备信息
      device_name: "Device Name",
      device_type: "Device Type",
      device_serial_number: "Serial Number",
      customer_name: "Customer",
      industry: "Industry",

      //设备保养计划
      service_plan: "Service Plan",
      next_service_time: "Next Service Time",
      next_service: "Next Service",
      delayed: "delayed", //23 days delayed
      天: "day(s)",
      service_detail: "Service Detail",

      //中部
      vacuum_status: "Vacuum Status",
      status_v: "Good", //演示用
      smart_maintenance: "Intelligent Maintenance",
      add_more_data: "Add more data",

      //测点数据
      realtime_data: "Show Realtime IoT Data",
      current: "Current",
      liquid_temp: "Liquid Temperature",
      customise_measurements_component: "Add or remove measurements",
      measurements: "Measurements",

      //底部按钮
      expert_view: "Expert View",
      intelligent_diagnose: "Intelligent Diagnose",
      audit_report: "Audit Report",
      energy_analysis: "Energy Anlaysis",
      device_lifecycle: "Lifecycle",
      online_store: "Nash Online Store",
      //智能诊断
      "Intelligent Diagnosis": "Intelligent Diagnosis",

      power_consumption: "Shaft Power",
      cooling_water_temp: "Cooling Water Temp",
      suction_pressure: "Suction Pressure",
      rotation_speed: "Rotation Speed",
      gas_displacement: "Gas Displacement",
      heat_exchange_ttd: "Heat Exchange TTD",
      //机组数据
      iot_info: "IoT Measurements",
      //设备报警
      device_event: "Device Events",
    },
  },

  base: {
    ok: "OK",
    delete: "Delete",
    delete_success: "Delete successful!",
    delete_failed: "Delete failed",
    delete_failed_please_try_again: "Upload failed, please try again!",
    upload: "Upload",
    upload_success: "Upload successful!",
    submit: "Submit",
    submit_success: "Submitted successfully",
    submit_failed: "Submission failure",
    delete_alert_title: "Sure to delete?",
    delete_alert_info: "This operation is irrevocable!",
    delete_alert_completed: "Deleted",
    done: "Confirm",
    cancel: "Cancel",
    refuse: "Refuse",
    confirm: "Confirm",
    pass: "Pass",
    edit: "Edit",
    permission: "Permissions",
    has_no_permission: "No operating privileges",
    prompt: "Prompt",
    error_request: "Request Error",
    add: "Add",
    add_success: "Added successfully",
    add_failed: "Failed to add",
    operation: "Operation",
    operate_success: "Successful operation",
    operate_failed: "Operation failure",
    modify: "Modification",
    modified_successfully: "Modified successfully",
    modified_failed: "Modification failure",
    refresh: "Refresh",
    detail: "Details",
    "Confirm to perform this operation?": "Sure to perform this action?",
    filter: "Screening",
    reset: "Reset",
    required: "Required field",
    "select-all": "Select All",
    export: "Export",
    "select-date": "Select date",
    "an-error-occurred": "An error occurred",
    "no-data": "No data available",
    save: "Save",
    saving: "Save in...",
    file_export_failed: "File export failed, please try again!",
    search_device_name: "Search by device name",
    unmatched_data: "No matching data",
    time: "times",
    type: "Type:",
    product: "Products:",
    last_modification_date: "Last modified date:",
    create_date: "Creation Date:",
    connection_status: "Connection Status",
    attribute: "Properties",
    gauge_point: "Measurement points",
    associated: "Associated Equipment",
    data_bank: "Database",
    tag: "Tags",
    no_attribute: "No Properties",
    add_attribute: "Add Properties",
    no_gauge_point: "No Measurement points",
    no_associated: "No associated equipment",
    no_tag: "No Tags",
    no_tending: "No maintenance items",
    picture: "Pictures",
    video: "Video",
    document: "Document",
    create_qrcode: "Generate QR code",
    data_type: "Data Type",
    select_customer: "Please select a customer",
    cancel_connect: "Cancel association",
    sure_cancel_connect: "Are you sure you want to cancel the association?",
    add_concact_device: "Add associated devices",
    input_tag_name: "Please enter the label name",
    input_tag_value: "Please enter the tag value",
    add_tag: "Add Tags",
    FilePictureData: "File photo material",
    save_success: "Save successfully",
    loading: "Loading...",
    update: "Update",
    ModifyFailedPleaseTryAgain: "Modification failed, please try again!",
    AddGroup: "Add group",
    exporting: "Exporting...",
    to: "To",
    name: "Name",
    import_pump: "Import Pump",
    iot_ready: "IOT Ready",
    yes: "Yes",
    no: "No",
    duplicate_name: "The account name already exists, please re-enter it.",
  },
  page: {
    "return-visit-remarks": "Return visit remarks",
    "service-ratings": "Service ratings",
    "service-provider": "Service Provider",
    "Real-Time Data Chart": "Real-Time Data Chart",
    "no-notification": "No notification",
    "download-failed-please-try-again": "Download failed, please try again!",
    "maintenance-item": "Maintenance Tasks",
    "please-check-maintenance-item":
      "Please check the maintenance tasks to be performed for this work order below. If none are listed, please manually enter them.",
    "service-company": "Agents",
    engineer: "Engineer",
    "complete-time": "Completion time",
    "business-account": "Company Account",
    "business-info": "Company Information",
    "permission-management": "Permission Management",
    "create-time": "Creation time",
    "set-column": "Set Columns",
    "industrial-equipment-manufacturing":
      "Industrial - Equipment Manufacturing",
    "industrial-equipment-maintenance": "Industrial - Equipment Maintenance",
    "basic-info": "Basic Information",
    ProductID: "Product ID:",
    "equipment-info": "Equipment Information",
    "select-type": "Select type",
    "work-order-type-required": "Work order type is mandatory",
    "expected-service-time": "Expected service time",
    "suggest-service-time": "Suggest service time",
    "service-time": "Service time",
    "select-time": "Select time",
    "work-order-content-required": "Work order content is required",
    "work-order-maintain-content-required": "Maintenance Tasks is required",
    "work-order-content": "Work order content",
    "service-agent-supplement": "To be supplemented by service agents",
    attachment: "Annexes",
    "assist-engineer": "Assist engineers",
    "expected-arrival-time": "Estimated arrival time",
    "expected-completion-time": "Estimated completion time",
    "drag-drop-or-click-to-upload":
      "Drag and drop to this area or click to upload",
    "cancel-work-order": "Cancellation of work orders",
    "apply-reassign": "Apply for reassignment",
    "dispatch-confirmation": "Dispatch Confirmation",
    "complete-work-order": "Work order completed",
    business: {
      Channel1: "Channel 1: Order Value this Month",
      OrderValueThisMonth: "Order Value this Month",
      Channel2: "Channel 2: Auditing",
      EstimatedOrderValueThisMonth: "Estimated Order Value this Month",
      Channel3: "Channel 3: Maintenance Package",
      Channel4: "Channel 4: IoT",
      OrderVolumeThisMonth: "Order Volume this Month",
      本月返厂大修计划: "This Month Overhaul Plan",
      全部返厂大修计划: "All Overhaul Plans",
      本月一级保养计划: "This Month's First Level Maintenance Plan",
      全部一级保养计划: "All First Level Maintenance Plans",
      本月二级保养计划: "This Month's Second Level Maintenance Plan",
      全部二级保养计划: "All Second Level Maintenance Plans",
      延期保养计划: "Deferred Maintenance Plan",
      全部延期保养计划: "All Deferred Maintenance Plans",
      待转化工单: "To be converted",
      已转化工单: "Converted",
      已完成: "Completed",
    },
    "company-size": {
      text: "Company Size",
      "less-than-25": "Less than 25 people",
      "25-100": "25-100 people",
      "100-300": "100-300 people",
      "more-than-300": "More than 300 people",
    },
    "customer-attr": {
      text: "Customer Properties",
      "non-ka": "Non-KA",
      ka: "KA",
      "supporting-household": "Supporting households",
      "engineering-company": "Engineering Company",
      export: "Export",
      industry: "Customer Industry",
      code: "Customer Code",
      address: "Customer Address",
      number: "Customer Phone",
      email: "Customer Email",
      web: "Customer Official Website",
    },
    "customer-industry": {
      general: "General",
      chemical: "Chemical",
      paper: "Paper Making",
      "oil-and-gas": "Oil and Gas",
      power: "Power",
      "nuclear-power": "Nuclear Power",
    },
    "app-industry": {
      "Sugar production": "Sugar production",
      Pharmaceuticals: "Pharmaceutics",
      "Chemical industry": "Chemical",
      "Medical treatment": "Medical Treatment",
      Medicine: "Medicine",
      Beer: "Beer",
      "Municipal administration": "Municipalities",
      Organosilicon: "Silicone",
      "Nuclear power": "Nuclear Power",
      Spandex: "Spandex",
      Wastewater: "Sewage",
      "Oil and gas": "Oil and Gas",
      "Carbon black": "Carbon Black",
      Tobacco: "Tobacco",
      "Coal chemical industry": "Coal Chemical",
      Coal: "Coal",
      "Coal mine": "Coal Mining",
      "Electric power": "Electric Power",
      Electronics: "Electronics",
      "Petrochemical industry": "Petrochemical",
      Mining: "Mining",
      "Grain and oil": "Grain and oil",
      Fiber: "Fiber",
      Equipment: "Equipment",
      Tire: "Tire",
      General: "General",
      Papermaking: "Papermaking",
      "Paper mill supporting households": "Paper mill supporting households",
      Supporting: "Supporting",
      Yeast: "Yeast",
      Steel: "Steel",
      "Aluminum industry": "Aluminum industry",
      Casting: "Casting",
      Food: "Food",
    },
    "service-request": {
      status: {
        text: "Status",
        "to-be-classified": "To be classified",
        pending: "Pending",
        processed: "Processed",
        canceled: "Canceled",
      },
    },
    "work-order": {
      WorkOrdersThisMonth: "Work Orders this Month",
      PendingAssignmentThisMonth: "Pending Assignment this Month",
      ClosedWorkOrdersThisMonth: "Closed Work Orders this Month",
      CanceledWorkOrdersThisMonth: "Canceled Work Orders this Month",
      TotalWorkOrders: "Total Work Orders",
      TotalPendingAssignment: "Total Pending Assignment",
      TotalClosedWorkOrders: "Total Closed Work Orders",
      TotalCanceledWorkOrders: "Total Canceled Work Orders",
      "create-order": "New Work Order",
      "create-customer-contact-error": "Error creating a new customer contact",
      "create-order-success": "Work order creation success",
      "customer-required": "Customers are a must",
      "contact-phone-required": "Contact number is required",
      "root-sn-required": "Root SN is required",
      "contact-required": "Contact person is required",
      address: "Repair Address",
      "pump-head-sn": "Pump head serial number",
      "unit-sn": "Unit serial number",
      number: "Work order number",
      type: {
        text: "Work Order Type",
        "device-repair": "Repair",
        "device-maintenance": "Service",
        "installation-debugging": "Installation",
        "fault-troubleshooting": "Troubleshooting",
        "QR-code": "QR Code",
        "maintenance-name": "Maintenance Name",
        "current-status": "Current status",
      },
      "current-status": {
        finished: "Finished",
        further_visit_necessary: "Further Visit Necessary",
      },
      "device-name": "Equipment name",
      "device-root-sn": "Serial number",
      "warranty-status": {
        text: "Warranty Status",
        "in-warranty": "In Warranty",
        "out-warranty": "Over Warranty",
      },
      contact: "Contact person",
      "contact-phone": "Contact number",
      "customer-name": "Customer Name",
      priority: {
        text: "Level of urgency",
        "not-urgent": "Not urgent",
        urgent: "Emergency",
        "very-urgent": "Very urgent",
      },
      "all-order": "All work orders",
      status: {
        text: "Work Order Status",
        pending: "Pending",
        "to-be-assigned": "Worker to be Assigned",
        unconfirmed: "Pending Confirmation",
        reassign: "Pending Reassignment",
        "pending-construction": "Pending On-Site Work",
        "under-construction": "Work in Progress",
        "awaiting-signature": "Awaiting Signature",
        completed: "Completed",
        canceled: "Canceled",
      },
      value: "Value",
      name: "Sub-device name",
      copy: "Reproduction",
      bulk_copy: "Bulk Copy",
      all_copy: "Total copies",
      in_copy: "Copy in...",
      copy_error: "Copy failed, please try again!",
      failed_to_device_list: "Failed to get device list, please try again!",
      failed_to_product_detail:
        "Failed to get product details, please try again!",
      ServiceInformation: "Service Information",
      ValueNotSelectedInCustomerList:
        "Values not selected in the customer list:",
      PackageName: "Package Name",
      PackageContent: "Package Content",
      ExpirationOfValidity: "Expiry date",
      Expires: "Expired",
      device: {
        text: "Equipment",
        rated_voltage: "Rated voltage",
        name: "Name",
        latest_value: "Latest Value",
        unit: "Unit",
        latest_time: "Latest Time",
        no_device_create: "No device created yet",
        device_create:
          "You can create a new device by clicking on the button in the upper right corner",
        last_value_timestamp: "Latest Value Timestamp",
        equipment_delivery_information: "Equipment factory information",
        device_management_information: "Equipment Management Information",
        edit: "Editing Equipment",
        create: "New construction equipment",
        mkdev: "Create Device",
        id: "Device ID:",
        single: "Single unit equipment",
        unit_type: "Unit Type",
        delete: "Delete Device",
      },
      factory_engineer: "OEM Eng.",
      authorized_engineer: "Auth. Eng.",
    },
    tending: {
      text: "Maintenance",
      item: "Maintenance Projects",
      names: "Maintenance Name",
      description: "Maintenance Description",
      service_provider: "Maintenance Service Provider",
      select_service_provider: "Please select the maintenance service provider",
      enter_project_name: "Please enter the project name",
      select_name: "Please select the maintenance name",
      name_connot_be_null: "Maintenance name cannot be empty",
      select_maintenance_period: "Please select maintenance interval",
      maintenance_period_cannot_be_empty: "Maintenance cycle cannot be empty",
      enter_description: "Please enter a description",
      add: "Add maintenance items",
      maintenance_period: "Maintenance cycle",
    },
    files_upload: {
      click_upload_pictures_videos_documents:
        "Click to upload pictures, videos and documents",
      click_upload_pictures_videos_documents_auditing:
        "Click to upload service callback documents",
      type_auditing: "EXCEL",
      type: "PPT、PDF、EXCEL、WORD、PNG、JPEG、JPG、MP4、MOV、GLB",
      document_type:
        "'.ppt,.pptx,.pdf,.xls,.xlsx,.doc,.docx,.png,.jpeg,.jpg,.mp4,.mov,.glb'",
      uploaded_data: "Uploaded information",
      file_size_cannot_exceed_50M: "File size cannot exceed 50M!",
      same_name_file:
        "The same name file already exists and cannot be uploaded repeatedly!",
      uploading: "Uploading...",
    },
    gauge_point: {
      alias: "Alias",
      runnable_low: "Runnable(low)",
      ideal_low: "Ideal(low)",
      ideal_high: "Ideal (High)",
      runnable_high: "Runnable (high)",
      enter_threshold_range: "Entry Threshold Range",
      threshold_range_is_not_entered: "Non-entry threshold range",
      unrecordable: "Unrecordable",
      runnable_low_cannot_be_null: "Runnable (low) cannot be empty",
      ideal_low_cannot_be_null: "Ideal (low) cannot be empty",
      ideal_high_cannot_be_null: "Ideal (high) cannot be empty",
      runnable_high_cannot_be_null: "Runnable (high) cannot be empty",
      add: "Add measurement points",
      show_or_not: "Show or Not",
    },

    no: "None",
    solid: "Occupy a seat",
    contract_name: "Contract Name",
    first_party: "Party A",
    second_party: "Party B",
    contract_file: "Contract Documents",
    contract_life: "Contract validity",
    PleaseSelectProperties: "Please select the property",
    delete_all_data:
      "Are you sure you want to delete it? This will delete all data associated with this device property.",
    parent_child_node:
      "The current device already has a parent-child node, please release the hierarchy relationship first.",
    parent_node:
      "The current device already has a parent node, please release the hierarchical relationship first.",
    child_node:
      "The current device already has a child node, please release the hierarchical relationship first.",
    edit_parent: "Edit parent node",
    edit_child: "Edit child nodes",
    character_length_cannot_exceed_50: "Character length cannot exceed 50",
    device_name_cannot_be_empty: "Device name cannot be empty",
    form_verification_failed:
      "The form verification did not pass, please check if the form is complete!",
    initialize_the_fetch_list: "Initialize get list ....",
    ready_fetch_list: "Prepare to get the list",
    fetch_result: "Results obtained:",
    submitting: "Submission in progress...",
    edit_success:
      "Edit device information successfully! Coming back to previous page",
    sava_fail: "Save failed:",
    device_create_success:
      "Create device information successfully! Coming back to previous page",
    create_fail: "Failed to create:",
    product_name_cannot_null: "Product name can not be empty, please re-enter!",
    device_name_cannot_null:
      "The device name cannot be empty, please re-enter it!",
    current_device_already_exists: "Current device already exists",
    "value_must_double_precision_number.": "Must be a double precision number.",
    data_type_double_default_value_fail:
      "When the data type in the property definition is a double-precision number, the default value is not filled in correctly!",
    must_be_integer: "Must be an integer.",
    data_type_integer_default_value_fail:
      "When the data type in the property definition is an integer, the default value is incorrectly filled in!",
    input_true_or_false: "Enter true or false",
    data_type_bool_default_value_fail:
      "When the data type in the property definition is a Boolean type, the default value is not filled in correctly!",
    tending_threshold_range_cannot_be_empty:
      "The threshold range of measurement points cannot be empty, please re-enter!",
    duplicate_alias: "Duplicate aliases",
    tending_duplicate_alias:
      "The alias of the measurement point is duplicated, please re-enter it!",
    maintenance_item_name_cannot_exceed:
      "Maintenance project names cannot exceed 50 in length, please re-enter!",
    maintenance_item_name_cannot_empty:
      "The maintenance project name cannot be empty, please re-enter it!",
    maintenance_name_cannot_empty:
      "Maintenance name cannot be empty, please re-enter!",
    maintenance_period_cannot_empty:
      "Maintenance interval cannot be empty, please re-enter!",
    maintenance_item_name_must_unique:
      "Maintenance project names cannot be duplicated, please re-enter!",
    maintenance_item_name_must_same_cycle:
      "Maintenance project name must be the same period, please re-enter!",
    MeasurementPointNameCannotExceed:
      "The name length in the measurement point definition cannot exceed 50, please re-enter it!",
    MeasurementPointNameCannotEmpty:
      "The name in the measurement point definition cannot be empty, please re-enter it!",
    MeasurementPointDataTypeCannotEmpty:
      "The data type in the measurement point definition cannot be empty, please select again!",
    MeasurementPointUnitCannotExceed:
      "The unit length in the measurement point definition cannot exceed 50, please re-enter!",
    MeasurementPointNameCannotRepeated:
      "The name in the definition of the measurement point cannot be repeated, please re-enter it!",
    GroupNameCannotBeRepeatedInThePropertyDefinition:
      "Group names cannot be duplicated in attribute definitions!",
    AttributeNamesInTheSameGroupOfAttributesCannotBeTheSameInTheAttributeDefinition:
      "Property names cannot be repeated within the same group of properties in the property definition!",
    AttributeDefinitionGroupNameCannotExceed:
      "The length of the group name in the property definition cannot exceed 50, please re-enter it!",
    AttributeDefinitionGroupNameCannotEmpty:
      "The group name in the property definition cannot be empty, please re-enter it!",
    AttributeDefinitionNameCannotExceed:
      "The name length in the property definition cannot exceed 50, please re-enter!",
    AttributeDefinitionNameCannotEmpty:
      "The name in the property definition cannot be empty",
    AttributeDefinitionDataTypeCannotEmpty:
      "The data type in the property definition cannot be empty, please reselect it!",
    AttributeDefinitionDefaulteLengthCannotExceed:
      "The default value in the property definition cannot exceed 50 in length, please re-enter!",
    ParentProductCannotBeEmpty:
      "The parent product cannot be empty, please select!",
    BasicInformationNameLengthCannotExceed:
      "The length of the name in the basic information cannot exceed 50, please re-enter!",
    BasicInformationNameCannotEmpty:
      "The name in the basic information can not be empty, please re-enter!",
    LastModificationTime: "Last modified time",
    DateCreated: "Creation Date",
    AttributeDefinition: "Property Definition",
    MeasurementPoint: "Measurement point definition",
    NoAttributeDefinition: "No attribute definition",
    NoMeasurementPoint: "No Measurement point definition",
    UndeletedInstancesCurrentProduct:
      "There is an undeleted instance under the current product, please delete the instance first.",
    ViewingAssociatedDevices: "View associated devices",
    DragDropFilesSelectFileUpload:
      "Drag and drop files to this area or select files to upload",
    unauthorized: "Unauthorized",
    CurrentUseHasNoAccessPermission:
      "The current user does not have access rights, please contact the administrator for authorization and try again",
    PleaseUploadAttachment: "Please upload the attachment",
    CurrentStatusIsRequired: "Current status is required",
    ConstructionRecordsWereSuccessfullyAdded:
      "Construction records added successfully",
    InitialStatusAddedSuccessfully: "Initial status added successfully",
    "device-attr": {
      contact_number: "Equipment Contact Phone",
      contacts: "Equipment Contact",
      Select_Down: "Please select the customer name below first",
      SelectUpperCustomer: "Please select the customer name above first",
      customer_purchasing_contact_number: "Customer Purchasing Contact Phone",
      customer_purchasing_contact: "Customer Purchasing Contact",
      delivery_time: "Shipping time",
      created_time: "Device creation time",
      number: "Equipment contact number",
    },
    "product-info": {
      text: "Product Information",
      type: "Product Type",
      name: "Products",
      select: "Please select a product",
      model_name_cannot_be_null: "Model name cannot be empty",
    },
    "service-report": {
      text: "Service Report",
      type: {
        text: "Report Type",
        "service-report": "Service Report",
        "return-visit-report": "Return visit report",
        "acceptance-report": "Out-of-box acceptance report",
        "on-site-training": "On-site training",
        "maintenance-report": "Maintenance Report",
        "debugging-report": "Equipment commissioning report",
      },
    },
    "role-management": {
      "current-role": "Current Role",
      "add-role": "Add Role",
      role: "Roles",
      "no-role": "No role at the moment",
      "role-permissions": "Role Permissions",
      "new-role": "New Roles",
      "Please set the name for the new role":
        "Please set a name for the new character",
      "New role added successfully!": "New role added successfully!",
      "Failed to add new role!": "Failed to add new role!",
      "Role name updated successfully!": "Role name updated successfully!",
      "Failed to update role name!": "Failed to update role name!",
      "Delete this role?": "Delete this role?",
      "Please delete the sub-roles first!":
        "Please delete the sub-roles first!",
      "Please select the role you want to operate on!":
        "Please select the role you want to operate on!",
      "please-select-role": "Please select the father role",
      "Please save the newly created role first!":
        "Please save the newly created role first!",
      "Invalid role": "Invalid role",
      "Role permissions updated successfully!":
        "Role permissions updated successfully!",
      "Failed to update role permissions!":
        "Failed to update role permissions!",
      "Delete all permissions of this role?":
        "Delete all permissions of this role?",
      "Role permissions deleted successfully!":
        "Role permissions deleted successfully!",
      "Failed to delete role permissions!":
        "Failed to delete role permissions!",
      代理商: "Agent",
      工程师: "Engineer",
      基本用户: "Basic User",
      客户: "Customer",
      设备联系人: "Device Contact Person",
      管理员: "Admin",
    },
    user: {
      unfreeze_account: "Unfreeze your account",
      freeze_account: "Freezing of accounts",
      role: "Role",
      account: "Account",
      name: "Name",
      email: "Email",
      "contact number": "Contact number",
      status: "Status",
      unregistered: "Unregistered",
      normal: "Normal",
      freeze: "Freeze",
      "Account information": "Account Information",
      "Select status": "Select Status",
      reset_password: "Reset Password",
      department: "Department",
      position: "Position",
      label: "Tags",
      post: "Jobs",
      contact_address: "Contact Address",
      CurrentPassword: "Current Password",
      NewPassword: "New Password",
      ConfirmPassword: "Confirm Password",
      registered_text: "Registered",
      unregistered_text: "Unregistered",
      user_exists: "This account already exists!",
      phone: "Phone",
    },
    "business-partner": {
      procurementContact: "Procurement Contact Person",
      contact: "Contact person",
      qualification: "Enterprise qualification",
      contract: "Contracts",
    },
    no_image: "No picture",
    create_time: "Creation time",
    construction_time: "Construction time",
    cancel_order: "Cancellation of work orders",
    apply_for_transfer: "Apply for reassignment",
    dispatch_confirmation: "Dispatch Confirmation",
    complete_work_order: "Completed work orders",
    client_signature: "Client Signature",
    work_order_progress: "Work Order Progress",
    service_company: "Service Company",
    customer_name: "Customer Name",
    estimated_arrival_time: "Estimated arrival time",
    estimated_completion_time: "Estimated completion time",
    pump_head_serial_number: "Pump head serial number",
    device_name: "Name",
    EquipmentManufacturer: "Equipment Manufacturers",
    unit_serial_number: "Unit serial number",
    locationOn: "Location",
    work_order_content: "Work order content",
    on_site_check_in: "On-site sign-in",
    "must operate on mobile": "Must be operated on mobile",
    construction_site: "Construction site",
    initial_status: "Initial Status",
    remaining_issus: "Remaining Issus",
    work_order_attachments: "Work Order Attachment",
    customer_feedback: "Customer Feedback",
    problem_description: "Problem Description",
    industry: "Industry",
    contact_number: "Contact number",
    email: "Email",
    homepage: "Official Website",
    company_address: "Company Address",
    contact: "Contact person",
    serviceEvaluation: "Service Evaluation",
    serviceQuality: "Service Quality",
    serviceAttitude: "Service attitude",
    responseSpeed: "Responsiveness",
    customerMessage: "Customer Message",
    signature: "Signature",
    veryProfessional: "Very professional, solved the problem quickly",
    canceled: "Canceled",
    dispatched: "Dispatch",
    construction: "Construction",
    completedWorkOrder: "Completion",
    completed: "Completed",
    processWait: "wait",
    workOrderProcessing: "In Operation",
    toBeConfirmed: "To be confirmed",
    deviceInfo: "Equipment Information",
    maintenanceRecord: "Maintenance records",
    relatedWorkOrder: "Related work orders",
    relatedServiceRequest: "Related service requests",
    powerOnTime: "Start-up time",
    deviceStatus: "Equipment Status",
    applicationIndustry: "Application Industry",
    workOrderCreationTime: "Work order creation time",
    estimatedArrivalTime: "Estimated arrival time",
    estimatedCompletionTime: "Estimated completion time",
    customerName: "Customer Name",
    device_category: "Equipment classification",
    model: "Model",
    status: "Status",
    allType: "All Types",
    report_number: "Report Number",
    type: "Type",
    device_serial_number: "Device Serial Number",
    customer: "Clients",
    contact_person: "Contact person",
    contact_phone: "Contact number",
    write_time: "Fill in time",
    serviceReport: "Service Report",
    add: "Add",
    reportNumberCustomerNameAgentDeviceSerialNumber:
      "Report Number/Customer Name/Agents/Device Serial Number",
    reportNumberCustomerNameAgentDeviceSerial:
      "Report Number/Agents/Device Serial Number",
    selectCreationTime: "Select creation time",
    pleaseSelectType: "Please select type",
    filter: "Screening",
    reset: "Reset",
    operation: "Operation",
    create: "New construction",
    wrongEmailFormat: "Wrong email format!",
    pleaseCompleteTheRequiredInformation:
      "Please complete the required information!",
    errorOnCreatingCustomerContact: "Error creating a new customer contact",
    serviceReportCreatedSuccessfully: "Service report created successfully",
    Customer_creation_success: "Customer creation success",
    reportType: "Report Type",
    pumpHeadSerialNumber: "Pump head serial number",
    contactPhone: "Contact number",
    fillingTime: "Fill in time",
    reportFile: "Report Documents",
    notEditable: "Current state cannot be modified",
    deleteConfirm: "Sure you want to delete?",
    afterSalesService: "After Sales Service",
    businessPartner: "Business Partners",
    agentName: "Agent Name",
    location: "Location",
    detailedAddress: "Detailed address",
    "select-industry": "Please select industry",
    "enterprise-contact": "Corporate Contact",
    "please-select-area": "Please select a region",
    "please-select-role": "Please select a role",
    downloading: "Download will start soon, please wait...",
    fileDownloaded: "The file has been downloaded!",
    clickHere: "Click here",
    startDownload: "Start downloading!",
    errorOccurred: "An error has occurred!",
    ifNotDownload: "If your file does not download automatically, click",
    "please-select-company-size": "Please select company size",
    companyIntroduction: "Company Profile",
    registerStatus: "Registration Status",
    selectRegisterTime: "Please select registration time",
    selectRegisterStatus: "Please select registration status",
    contactNumber: "Contact number",
    officialWebsite: "Official Website",
    companyAddress: "Company Address",
    establishedTime: "Establishment time",
    companySize: "Company Size",
    valid: "Valid",
    expired: "No longer valid",
    "no-equipment-record": "No equipment records have been generated yet",
    "business-status": {
      pending: "To be converted",
      converted: "Converted",
      completed: "Completed",
    },
    "business-number": "Business opportunity number",
    "maintenance-name": "Maintenance Name",
    "device-type": "Equipment Type",
    "delay-status": "Extension Status",
    "delay-reason": "Reason for extension",
    "delay-or-complete-reason": "Reason for extension/completion",
    "business-finish-time": "Business opportunity completion time",
    all: "All",
    NoOption: "No option at this time",
    NoResultFound: "No results found",
    "health-monitoring": {
      threshold_interval_diagram: "Threshold interval chart",
      historical_data: "Historical Data",
      search: "Search",
      refresh_rate: "Refresh Frequency:",
      Every3Seconds: "Every 3 seconds",
      Every15Seconds: "Every 15 seconds",
      Every60Seconds: "Every 60 seconds",
      viewing_historical_data: "View Historical Data",
      unfold: "Expand",
      pack_up: "Put away",
      health_monitoring_list: "Health Monitoring List",
      measuring_point_name: "Measurement point name",
      EarlyWarningState: "Early warning status",
      LastUpdateTime: "Last update time",
      CurrentValue: "Current Value",
      UnitName: "Unit name",
      DeviceArea: "Area where the equipment is located",
      search_placeholder:
        "Search for customer name/serial number/Industry/applications",
      custom: "Custom",
      monomer: "Monomer",
      set: "Set",
      serialNumber: "Serial Number",
      type: "Type",
      type1: "Model",
      status: "Running State ",
      status1: "Health Status",
      time: "Run Time",
      scene: "Industry-Applications",
    },
    "event-management": {
      search_placeholder: "Serial Number/Customer Name",
      EventRecording: "Event Log",
      EventNumber: "Event Number",
      IntelligentAlarm: "Smart Alarm",
      warning: "Warning",
      error: "Error",
      reminder: "Reminder",
      AffectedEquipment: "Affected Equipment",
      AffectedSensor: "Affected Sensors",
      OccurrenceTime: "Time of occurrence",
      PredictiveMaintenanceModule: "Predictive Maintenance Module",
      BriefDescription: "Brief description",
      AbnormalPerformancePleasePayAttention:
        "Behaving abnormally, please pay attention.",
      enter: "Entered",
      EventMap: "Event Mapping",
      FaultCauseAnalysisSuggestions: "Failure cause analysis suggestions",
      RelatedProcessDescription: "Related process description",
      RelativeResults: "Related results",
      EventBase: "Event Library",
      UpdateTime: "Update time",
      EventReport: "Event Report",
      DescribeEventImpactProblem:
        "Describe the event, the impact, and the way the problem was solved in the text box below.",
      HistoricalReport: "History Report",
      NoHistoricalReport: "No historical report",
      click_upload_pictures: "Click to upload picture",
      UploadedPicture: "Uploaded pictures",
      NoUploadedPicture: "No uploaded pictures",
      ClickUploadDocument: "Click to upload a document",
      UploadedDocument: "Uploaded documents",
      NoUploadedDocument: "No uploaded documents",
      "sub-health": "Subhealth",
      abnormal: "Anomalies",
      health: "Health",
      unknown: "Unknown",
      FileWithTheSameNameAlreadyExists:
        "The same name file already exists and cannot be uploaded repeatedly!",
      EventPicture: "Event Photos",
      DynamicThresholdHigh: "Dynamic threshold (high)",
      DynamicThresholdLow: "Dynamic threshold (low)",
      EventType: "Event Type:",
      EventStatus: "Event Status:",
      EventList: "Event List",
      status: "Event Status",
      RequestFailedPleaseTryAgain: "Request failed, please try again!",
      DeviceHasNoEventRecord: "There is no event record for the current device",
      FailedGetEventListPleaseTryAgain:
        "Failed to get the event list, please try again!",
      FailedGetEventDetailPleaseTryAgain:
        "Failed to get event details, please try again!",
      BatchModification: "Batch modification in progress...",
      BatchModifying: "Batch Modification!",
      StatusChangedSuccessfully: "Modify status successfully",
      FailedModifyStatusPleaseTryAgain:
        "Failed to modify the status, please try again!",
      start: "Open",
      BeingProcessed: "In process",
      WaitForConfirmation: "Waiting for confirmation",
      closed: "Closed",
      HavePublished: "Released",
      resloved: "Resolved",
    },
    "atlas-analysis": {
      SelectedData: "Selected data",
      "time granularity": "Time granularity",
      reach: "To",
      StaticThreshold: "Static threshold:",
      DynamicThreshold: "Dynamic thresholds:",
      PleaseFirstDragTheMeasuringPointOnTheLeftSideToPlaceItOnTheChart:
        "Please first drag and drop the measurement points on the left side to place them on the chart",
      sed: "seconds",
      min: "Minutes",
      hour: "Hours",
      day: "Day",
      Last7Days: "Last 7 days",
      ThisMonth: "This month",
      LastMonth: "Last month",
      TMonth: "Three months",
      CreatedAt: "Created in",
      ChartAnnotation: "Chart Notes",
      DataSnapshots: "Data Snapshot",
      SelectMeasurement:
        "Please select the measurement value from the left and drag it to this box",
      AITechnologyTool:
        "Use artificial intelligence technology as a tool to achieve intelligent upgrading of equipment maintenance. Through data mining technology, identify the relevance of process features hidden in the data in order to discover the causes of production quality abnormalities in a timely manner and improve the operation of production lines.",
      OfAnnotation: "The notes of",
      face: "Face",
      describe: "Description:",
      PleaseInput: "Please enter",
      SelectPatternColor: "Select pattern color:",
      SelectedRangeExceedsTheMaximumDataLimit:
        "The selected range exceeds the maximum data limit!",
      "1MillInputShaftAxialX": "1#Mill input shaft axial (X)",
      "1MillInputShaftAxialY": "1#Mill input shaft axial (Y)",
      GenerateAlarm1111:
        "Vibration value exceeds the threshold range, generating alarm 1111",
      GenerateAlarm2222:
        "Vibration value exceeds the threshold range, generating alarm 2222",
      GenerateAlarm1234:
        "Vibration value exceeds the threshold range, generating alarm 1234",
      ChooseMaximumOf6MeasuringPoints: "Select up to 6 measurement points",
      Annotation: "Note",
      DT: "Dynamic Threshold",
      MapDataRequestFailed: "Mapping data request failed",
      PleaseSelectCommentNodeLineChart:
        "Please check the comment node in the line chart",
      PleasePlaceLeft:
        "Please drag and drop the measurement points on the left side to place them here first.",
      TriggerEvent: "Trigger events",
      TriggeredMethod: "Interval greater than 2 seconds, trigger method",
      NoTrigger: "No Trigger",
      DataScience: "Data Science",
      ComingSoon: "Please look forward to!",
    },
    "expert-system": {
      ExpertStatement: "Expert Notes",
      ProcessDescription: "Process Description",
      ThresholdProcessManagement: "Threshold and Process Management",
      ThresholdManagement: "Threshold Management",
      Enabled: "Enabled",
      NotEnabled: "Not enabled",
      CanontBeEmpty: "Cannot be empty",
      MustBeANumber: "Must be digital",
      CurrentDetectionPointThresholdNotEnabled:
        "The threshold switch of the current measurement point is not turned on, click the button below to operate",
      StaticThresholdSwitchCannotBeOperated:
        "The current measurement point can be recorded in the threshold switch is not turned on, can not operate the static threshold switch, click the button below to operate",
      go: "Go to",
      EditObjectInstance: "Example of editorial material",
      ChangingStaticThresholdSucceeded: "Modify static threshold successfully!",
      FailedModifyStaticThresholdPleaseTryAgain:
        "Failed to modify the static threshold, please try again!",
    },
    "personal-information": {
      text: "Personal Information",
      ChangePassword: "Change password",
    },
    "product-library": {
      SelectTheProductLibraryBaseType: "Select product library base type",
      DefinitionOfProduct:
        "The product contains definitions of common attribute names, hierarchies, methods and compositions for a class of devices.",
      SearchForProductName: "Search Product Name",
      CreateProduct: "Create Product",
      CreateProductsAtThisLevel: "Create products at this level",
      ViewDetails: "View Details",
      NewProduct: "New Construction Products",
      PleaseEnterAGroupName: "Please enter the group name",
      PleaseEnterAPropertyName: "Please enter the name of the property",
      SelectADefaultValueForTheProperty:
        "Please select the default value of the property",
      PleaseEnterTheDefaultValueOfTheProperty:
        "Please enter the default value of the property",
      AreYouSureWantDelete: "Are you sure you want to delete it?",
      DefaultVlue: "Default Value",
      PleaseEnterName: "Please enter a name",
      ProductManagement: "Product Management",
      EditProduct: "Editorial Products",
      OtherInformation: "Other Information",
      maintain: "Maintenance",
      RequestFailedPleaseTryAgain: "Request failed, please try again",
      SavedSuccessfullyWillJumpDetailsPage:
        "Save successfully, will jump to the details page soon",
      ProductNameHasBeenRepeated:
        "Product name has been repeated, please re-enter",
      CreationSuccessfulWillJumpProductPage:
        "Created successfully, will jump to the product screen soon",
      PleaseEnterThePointName: "Please enter the name of the measurement point",
      PleaseEnterThePointUnit: "Please enter the measurement point unit",
      NoProductHasBeenCreated: "No products created yet",
      YouCanCreateANewProduct:
        "You can create a new product by clicking on the button in the upper right corner",
      LatestTimestamp: "Latest Timestamp",
      DeleteProduct: "Delete Product",
      FailedToGetProductList: "Failed to get product list, please try again!",
      FailedToGetProductDetails:
        "Failed to get product details, please try again!",
      ThisProductAssociatedInstance:
        "This product is associated with an instance, please unassociate it and then delete it.",
      ProductName: "Product Name",
    },
    "repair-request": {
      RequestsThisMonth: "Requests this Month",
      PendingRequestsThisMonth: "Pending Requests this Month",
      ClosedRequestsThisMonth: "Closed Requests this Month",
      CanceledRequestsThisMonth: "Canceled Requests this Month",
      SelectRequestType: "Select request type",
      TotalPendingRequests: "Total Pending Requests",
      TotalClosedRequests: "Total Closed Requests",
      TotalCanceledRequests: "Total Canceled Requests",
      NotClassified: "Uncategorized",
      CancelRequest: "Cancel Request",
      PleaseEnterReasonForCancellation:
        "Please enter the reason for cancellation",
      TotalRequest: "Total requests",
      FaultMessage: "Fault Information",
      TheFieldUpdatedTo: "The field is updated to",
      CancelReason: "Reason for cancellation",
      SettlementRecord: "Solution Record",
      DirectSolution: "Direct solution",
      CreateWorkOrder: "Create Work Order",
      RecordDescription: "Record Description",
      SolicitedMessage: "Request Information",
      RequestType: "Request Type",
      TheDegreeOfUrgencyIsRequired: "The degree of urgency is a required field",
      TheCompanyNameIsRequired: "Company name is a must",
      TheRootSNIsRequired: "Root SN is a must",
      ExpectedServiceTimeIsRequired: "Expected service time is a must",
      DeviceQueryFailure: "Device query failure",
      AfterSelectingTheEquipment: "After selecting the device...",
      ValuesNotSelectedInTheDeviceList: "No selected value in the device list:",
      CurrentDeviceSerialNumberChanges: "Current device serial number change:",
      GetStateFailure: "Access to countries failed:",
      remaining: "Remaining",
      service_request_no: "Service Request No.",
    },
    maintenance: {
      FirstLevelMaintenance: "First level of Maintenance",
      SecondLevelMaintenance: "Second level of Maintenance",
      ReturnToFactoryForOverhaul: "Return to factory for overhaul",
      DailyMaintenance: "Daily Maintenance",
      EveryYear: "Every 1 year",
      EveryTwoYears: "Every 2 years",
      EveryThreeYears: "Every 3 years",
      EveryFiveYears: "Every 5 years",
      EveryEightYears: "Every 8 years",
      EveryDay: "Every Day",
      EveryWeek: "Every Week",
      EveryMonth: "Every Month",
      EveryQuarter: "Every Quarter",
      EveryHalfYear: "Every Half Year",
    },
    "please-enter-content": "Please enter the content",
    "begin-month": "Start month",
    "end-month": "End month",
    unread: "Unread",
    notifications: "Notifications",
    overdue: "Overdue",
    "not-overdue": "Not overdue",
    "no-explain": "No explanation",
    "add-explain": "Add explanation",
    "view-more": "View more",
    "business-delay-reason": {
      "-1": "Not filled",
      1: "No equipment",
      2: "Contact information error",
      3: "Customer maintenance",
      4: "Reschedule according to the downtime",
      5: "No on-site maintenance required, only purchasing spare parts",
    },
    "get-explain-fail": "Get explanation failed",
    "add-explain-success": "Add explanation successfully",
    "add-explain-fail": "Add explanation failed",
    "get-maintenance-item-fail": "Get maintenance item failed",
    "business-confirm-transfer": "Transfer to work order？",
    "business-confirm-cancel-transfer": "Revert transfer？",
    "unread messages": "Unread messages",
    new: "New",
    "maintenance-download-title": "Maintenance",
    "business-opportunity-download-title": "Business-Opportunity",
    "work-order-download-title": "Work-Order",
    "history-explain": "History explanation",
    explanation: "Explanation",
    "downloading...": "Downloading...",
    "start-time": "Start time",
    "end-time": "End time",
    logout: "Logout",
    feedback_content_placeholder:
      "Please feel free to share any further opinions or suggestions.",
    rate: {
      0: "Please rate",
      1: "1 point",
      2: "2 points",
      3: "3 points",
      4: "4 points",
      5: "5 points",
    },
    feedback_submit: "Submit",
    quality_required: "Please rate the service quality",
    attitude_required: "Please rate the service attitude",
    response_speed_required: "Please rate the response speed",
    "please-evaluate":
      "Please provide an evaluation for the engineer who serviced your work order this time.",
    "no-evaluate": "Not yet signed.",
    "pending-evaluation": "Awaiting Evaluation",
    "less-than-3-points": "Below 3 stars",
    "more-than-3-points": "3 stars and above",
    products: "Products",
    select_is_qrcode_bind: "Please select whether to bind the QR code",
    registered: "Registered",
    unregistered: "Unregistered",
    register_time: "Registration time",
    no_checkin_address: "The location address was not obtained",
    parts_amount: "Parts amount",
    parts_explain: "Parts explanation",
    reason_explain: "Reason explanation",
    fault: {
      fault_knowledge_base: "Fault knowledge base",
      correlative_measuring_points: "Correlative measuring points",
      fault_classification_required: "Fault Classification is required",
      fault_description: "Fault description",
      fault_symptoms: "Fault symptoms",
      fault_cause: "Fault cause",
      resolution: "Resolution",
      add_fault_information: "Add fault information",
      add_fault_description: "Add fault description",
      no_fault_description: "No Fault Description",
    },
    energy_consumption_analysis: {
      智能系统年度总收益: "Annual Total Tevenue of Intelligent Systems",
      机组年度节电收益: "Annual Electricity-Saving Earnings of The Unit",
      机组: "Unit Energy ",
      节能图表: " Savings Chart",
      节约电费: " Save Electricity",
      减少CO2排放: " Reduce CO2 Emissions",
      总电费: " Total Electricity Charge",
      产生CO2排放: " Generate CO2 Emissions",
      节水收益: "Water-Saving Benefits",
    },
    energy_consumption_management: {
      title: "Energy Consumption Management",
      每度电煤耗: "Coal consumption per kilowatt-hour",
      CO2交易价格: "CO2 trading price",
      煤炭价格: "Coal price",
      电费的价格: "Price of electricity",
      预测性维护节省收益: "Predictive maintenance saves revenue",
      data_name: "Data Name",
      value: "Value",
    },
    auditing: {
      title: "Auditing Work Order",
      service_follow_up: "Service Follow-up",
      service_upload: "Upload",
      work_order_number: "Work Order Number",
      type: "Type",
      customer_level: "Customer level",
      latest_completion_time: "DDL.",
      work_order_status: "Work order status",
      delay_status: "Delay status",
      customer_name: "Customer",
      service_provider: "Service provider",
      sales_service_engineer: "Sales Service Engineer",
      contact: "Contact", //指联系人
      contact_phone: "Phone",
      service_report_status: "Service Report Status",
      amount: "Amount",
      order_feasibility: "Feasibility of Closing",
      service_report: {
        in_progress: "In Progress",
        to_review: "Pending Review",
        to_sign: "Pending Signature",
        signed: "Signed",
      },
      service_process: "Service Process",
      KA_customer_level: "KA Customer Level",
      province: "Province",
      detailed_address: "Detailed Address",
      last_execution_time: "Last Execution Time",
      work_order_notes: "Work Order Notes",
      dispatch_information: "Dispatch Information",
      service_type: "Service Type",
      history: "History",
      customer_contact: "Customer Contact",
      NASH_service: "NASH Service",
      technical_service_engineer: "Technical Service Engineer",
      agent_service: "Agent Service",
      repair_service_engineer: "Repair Service Engineer",
      authorized_service_engineer: "Authorized Service Engineer",
      service_progress: "Service Progress",
      customer_signature: "Customer Signature",
      "Basic Contact Information": "Basic Contact Information",
      departure_time: "Departure Time",
      arrival_time: "Arrival Time",
      leave_time: "Leave Time",
      "Equipment Information": "Equipment Information",
      unallocated_individual_equipment: "Unallocated Individual Equipment",
      name: "Name",
      position_no: "Position No.",
      installation_and_debugging_time: "Installation and Debugging Time",
      operation_time: "Operation Time",
      factory_release_time: "Factory Release Time",
      uploaded_nameplate: "Upload Nameplate",
      equipment_appearance: "Equipment Appearance",
      equipment: "Equipment",
      "Diagnostic Records": "Diagnostic Records",
      possible_abnormal_measurement_points:
        "Possible Abnormal Measurement Points",
      fault_performance: "Fault Performance",
      preliminary_analysis_reason: "Preliminary Analysis Reason",
      solution: "Solution",
      remarks: "Remarks",
      maintenance_suggestions: "Maintenance Suggestions",
      enter_maintenance_suggestions: "Enter Maintenance Suggestions",
      add_maintenance: "Add Maintenance",
      specification: "Specification",
      quantity: "Quantity",
      spare_parts_suggestions: "Spare Parts Suggestions",
      opportunity_name: "Opportunity Name",
      opportunity_type: "Opportunity Type",
      stage: "Stage",
      estimated_value: "Estimated Value",
      total: "Total",
      opportunity_conversion: "Opportunity Conversion",
      measurements: "Measurements",
      是否删除该设备: "Do you want to delete this device?",
      select_equipment: "Select Equipment",
      equipment_list: "Equipment List",
      undiagnosed_equipment: "Undiagnosed Equipment",
      add_diagnosis: "Add Diagnosis",
      suggestions: "Suggestions",
      service_suggestions: "Service Suggestions",
      add_service: "Add Service",
      no_recommended_equipment: "No Recommended Equipment",
      abnormal_equipment: "Abnormal Equipment",
      add_contact: "Add Point of Contact",
      selcet_contact: "Select Point of Contact",
      请在小程序上签到: "Please Sign In on the App",
      submit_approval: "Submit for Approval",
      驳回原因: "Reason for rejection",
      审核通过后等待签字验收:
        "After approval, the service report will be generated and sent to the point of contact for signature and acceptance.",
      repairs: "Repairs",
      maintenance: "Maintenance",
      spare_parts: "Spare Parts",
      repair_level: {
        overhauls: "Overhauls",
        medium_repair: "Medium Repair",
        minor_repairs: "Minor Repairs",
      },
      units: "Units",
      bit_no: "Position No.",
      unit_usage: "Unit Usage",
      technical_transformation: "Technical Transformation",
      replace: "Replace",
      normal_equipment: "Normal Equipment",
      是否可能异常: "Abnormality",
      health_score: "Health Score",
      measurement_point_value: "Measurement Point Value",
      是否正常: "Is it normal",
      fault_name: "Fault Name",
      fault_description: "Description",
      初步分析原因: "Causes",
      可能造成影响: "Possible Impacts",
      建议解决方案: "Solution",
      suggest_types: "Suggest Types",
      maintenance_type: "Maintenance Type",
      maintenance_project: "Maintenance Project",
      accessories_type: "Accessories Type",
      请优先选择配件类型: "Please give preference to the type of accessory.",
      accessories_list: "Accessories List",
      quantity_label: "Quantity",
      GDNC_description: "GDNC Description",
      add_new_contact: "Add New Point of Contact",
      不存在: "Does Not Exist",
      "商机转换未填写，请填写完整后提交审核":
        "The opportunity conversion is not filled, please complete it and submit it for review.",
      服务过程未完成: "The service process is not complete.",
      诊断记录未填写完整:
        "The diagnostic record is not complete, please fill it out and submit it for review.",
      服务建议未填写完整:
        "The service proposal is not complete, please submit it for review after completing it.",
      商机转换未填写:
        "The opportunity conversion is not filled, please complete it and submit it for review.",
      铭牌删除成功: "The nameplate was removed successfully.",
      设备外观删除成功: "The device appearance is deleted.",
      铭牌上传成功: "The nameplate has been uploaded successfully.",
      设备外观上传成功: "The device appearance is successfully uploaded.",
      只能输入整数: "Only integers can be entered.",
      请填写设备信息: "Please fill in the device information.",
      删除联系人: "Delete the contact.",
      log: {
        待施工: "Pending On-Site Work",
        "您的设备巡检已被受理，销售工程师 ":
          "Your equipment inspection has been accepted, sales engineer",
        增加协助人: "Add Assistant",
        新增了技术服务工程师: "Added technical service engineer",
        新增了授权服务工程师: "Added authorized service engineer",
        更换协助人: "Change Assistant",
        您的技术服务工程师更换:
          "Your Technical Service Engineer has been changed",
        您的授权服务工程师更换:
          "Your Authorized Service Engineer has been changed",
        已签到: "Checked in",
        服务人员: "Service Personnel",
        服务地点: "Service Location",
        更换Owner: "Change Owner",
        您的销售服务工程师更换: "Your Sales Service Engineer has been changed",
        提交审核: "Submit for Review",
        技术工程师: "Technical Engineer",
        销售工程师: "Sales Engineer",
        审核通过: "Review Approved",
        审核不通过: "Review not Approved",
        "审核拒绝，拒绝原因": "review rejected, reason for rejection",
        服务报告签字: "Service Report Signature",
        已完成: "Completed",
        客户联系人: "Customer contact",
        已完成服务报告签字: "signings  the service report.",
        "所有服务报告签字完成，设备巡检工单完成":
          "All service reports are signed and equipment inspection work orders are completed.",
      },
      销售服务工程师修改成功: "The sales service engineer has been changed!",
      技术服务工程师修改成功:
        "The technical service engineer has been changed!",
      代理服务修改成功: "The Agent service has been changed!",
      授权服务工程师修改成功:
        "The authorized service engineer has been changed!",
      暂无联系人: "No contacts",
      暂无图片: "No images",
      请完善设备测点: "Please fill in the measurement information!",
      请选择设备: "Please select the device! ",
      请填写故障的故障名称: "Please fill in the fault name for Fault ",
      请填写初步分析原因: "Please fill in the preliminary analysis result!",
      请对设备做出体检评分:
        "Please provide a health check score for the device!",
      请选择建议类型: "Please select the suggestion type!",
      请填写维保类型和维保项目:
        "Please fill in the maintenance type and maintenance items!",
      请填写配件类型: "//Please fill in the part type!",
      请填写设备型号: "Please fill in the device model!",
      请填写Care类型: "Please fill in the Care type!",
    },
  },
  menu: {
    dashboard: {
      text: "Dashboard",
    },
    "after-sales_service": {
      text: "After Sales Service",
      service_request: "Service Request",
      order: {
        text: "Work Order Management",
        "equipment-repair": "Equipment Maintenance",
        "equipment-maintenance": "Equipment Maintenance",
        "installation-debugging": "Installation and commissioning",
        troubleshooting: "Troubleshooting",
      },
      report: "Service Report",
      "business-opportunity": "Business Opportunity Management",
      "maintenance-plan": "Maintenance Plan",
    },
    "equipment-management": {
      text: "Equipment Management",
      search: "Name/Serial Number/Model",
      "model-management": {
        text: "Model Management",
        model: "Product Library",
        instance: "Equipment",
      },
      equipment: "Equipment Management",
      AddEquipment: "Add Devices",
      export: "Device Export",
      import: "Device Import",
      ColumnSelected: "columns have been selected",
      QrcodeExport: "QR Code Export",
      EnterDeviceInformationClick:
        "Please fill in the device information according to the template file requirements and use the import function, click",
      download: "Download",
      ObtainTheDeviceTemplate: "Get device templates",
      ToChannel: "Import",
      accomplish: "Completion",
      DeviceList: "Equipment List",
      QrcodeBinding: "QR code binding",
      DeviceQRcodeZip: "Device QR Code.zip",
      DeviceListExportZip: "Device List Export.zip",
      Bound: "Bound",
      NotBound: "Unbound",
      UnabletoBound: "Unable to bound",
      ImportDevice: "Importing devices",
      EquipmentAssetCoding: "Equipment Asset Code",
      DocumentType: "Documents (WORD, EXCEL, PPT, PDF)",
      SearchDocumentName: "Search by document name",
      NoFileHasBeenUploaded: "No document uploaded yet",
      NoPictureVideoHasBeenUploaded: "No picture video uploaded yet",
      FullLifeCircle: "Full Lifecycle",
      AssociatedGroupTypeDevice: "Associated unit type equipment",
      AssociatedIndividualDevice: "Associated Single Unit Equipment",
      risk: "Danger",
      FailedToObtainDeviceDetailsPleaseTryAgain:
        "Failed to get device details, please try again!",
      total_equipment: "Total Equipment",
      annual_equipment_installed_capacity:
        "Annual Equipment Installed Capacity",
      please_rename_the_file_and_try_uploading_again:"File name can only include Chinese characters, letters, numbers, and underscores. Please rename and re-upload."
    },
    "business-partner": {
      text: "Business Partners",
      manufacturer: "Equipment Manufacturers",
      "service-company": "Agents",
      customer: "Clients",
    },
    "system-management": {
      text: "System Administration",
      "role-management": "Role Management",
      "user-management": "User Management",
      "energy-consumption-allocation": "Energy Consumption Allocation",
    },
    "intelligent-operation-maintenance": {
      text: "Intelligent Operations and Maintenance",
      "health-monitor": "Health Monitoring",
      event: "Event Management",
      "data-analysis": "Graphical analysis",
      "expert-service": "Expert System",
      "intelligent-diagnosis": "Intelligent Diagnosis",
    },
  },
  manufacturer: {
    text: "Equipment Manufacturers",
    "email-error": "Mailbox format error",
    error: "An error occurred",
    "device-manufacturer-name": "Name of equipment manufacturer",
  },
  serviceCompany: {
    certificate_name: "Certificate Name",
    awarding_body: "Issuing Institution",
    not_null: "(required)",
    indate: "Expiration date",
    certificate_photo: "Certificate photo",
    begin_date: "Start Date",
    end_date: "End date",
    create_success: "Created successfully",
    company_name: "Company Name",
  },
  also: {
    support: "Support",
    FileSizeDoesNotExceed: "The file size does not exceed",
    ClickUpload: "Click to upload",
    ProductLibraryContainsDefinitions:
      "The product library contains definitions of common attribute names, hierarchies and method names for a class of devices.",
    ParentProduct: "Parent Products",
    ExpectedDate: "Expected date of service",
    PropertyDeviceThatNotChangeEasily:
      "A property of a device that does not change easily or at all.  For example, serial number, installation date, rated power, etc. ",
    FrequentlyChangingPropertiesDevice:
      "Frequently changing properties in the device.  Such as instantaneous current, voltage, vibration, etc.  Frequently changing properties in the device.  Such as instantaneous current, voltage, vibration, etc. ",
    CreateMaintenanceItems: "Create maintenance items",
    ProductRelatedDiagramsVideosDocuments:
      "Product related diagrams, videos, documents",
    UsedToRetrieveProducts: "Used to retrieve products",
    BusinessInformation: "Business Information",
    CharacterString: "String",
    integer: "Integer",
    "double-precisionNumber": "Double-precision Number",
    boolean: "Boolean",
    "last name": "Last name",
    "first name": "First name",
    total: "Total:",
    item: " Item",
    "next page": "Next Page",
    "jump to": "Jump to",
    page: "Page",
    "previous page": "Previous Page",
    "please select": "Please Select",
    SelectingTheEquipment: "Selecting the equipment",
    inAll: "In all",
    SuperAdmin: "super admin",
    EquipmentManager: "Equipment manager",
    IntelligentOperationPlatform:
      "Nash Intelligent IIoT Equipment Management System",
  },

  province: {
    中国: "China",
    北京: "Bei Jing",
    天津: "Tian Jin",
    河北: "He Bei",
    山西: "Shan Xi",
    内蒙古: "Nei Meng Gu",
    辽宁: "Liao Ning",
    吉林: "Ji Lin",
    黑龙江: "Hei Long Jiang",
    上海: "Shang Hai",
    江苏: "Jiang Su",
    浙江: "Zhe Jiang",
    安徽: "An Hui",
    福建: "Fu Jian",
    江西: "Jiang Xi",
    山东: "Shan Dong",
    河南: "He Nan",
    湖北: "Hu Bei",
    湖南: "Hu Nan",
    广东: "Guang Dong",
    广西: "Guang Xi",
    海南: "Hai Nan",
    重庆: "Chong Qing",
    四川: "Si Chuan",
    贵州: "Gui Zhou",
    云南: "Yun Nan",
    西藏: "Xi Zang",
    陕西: "Shan Xi",
    甘肃: "Gan Su",
    青海: "Qing Hai",
    宁夏: "Ning Xia",
    新疆: "Xin Jiang",
    香港: "Xiang Gang",
    澳门: "Ao Men",
    台湾: "Tai Wan",
    北京市: "Bei Jing",
    天津市: "Tian Jin",
    河北省: "He Bei",
    山西省: "Shan Xi",
    内蒙古自治区: "Nei Meng Gu",
    辽宁省: "Liao Ning",
    吉林省: "Ji Lin",
    黑龙江省: "Hei Long Jiang",
    上海市: "Shang Hai",
    江苏省: "Jiang Su",
    浙江省: "Zhe Jiang",
    安徽省: "An Hui",
    福建省: "Fu Jian",
    江西省: "Jiang Xi",
    山东省: "Shan Dong",
    河南省: "He Nan",
    湖北省: "Hu Bei",
    湖南省: "Hu Nan",
    广东省: "Guang Dong",
    广西壮族自治区: "Guang Xi",
    海南省: "Hai Nan",
    重庆市: "Chong Qing",
    四川省: "Si Chuan",
    贵州省: "Gui Zhou",
    云南省: "Yun Nan",
    西藏自治区: "Xi Zang",
    陕西省: "Shan Xi",
    甘肃省: "Gan Su",
    青海省: "Qing Hai",
    宁夏回族自治区: "Ning Xia",
    新疆维吾尔自治区: "Xin Jiang",
    香港特别行政区: "Xiang Gang",
    澳门特别行政区: "Ao Men",
    台湾省: "Tai Wan",
    南海诸岛: "South China Sea Islands",
    出口: "Export",
  },

  所属机组序列号: "Affiliated Unit Serial Number",
  设备名称: "Device Name",
  设备厂商: "Device Manufacturer",
  设备品牌: "Device Brand",
  设备型号: "Device Model",
  额定电流: "Rated Current",
  序列号: "Serial Number",
  发货时间: "Delivery Time",
  设备状态: "Device Status",
  设备创建时间: "Device Creation Time",
  设备资产编码: "Device Asset Code",
  质保开始时间: "Warranty Start Time",
  质保到期时间: "Warranty End Time",
  应用行业: "Applied Industry",
  所在位置: "Location",
  详细地址: "Detailed Address",
  应用车间: "Applied Workshop",
  应用工艺: "Applied Process",
  设备联系人: "Device Contact Person",
  设备联系电话: "Device Contact Phone",
  维保服务商: "Maintenance Service Provider",
  客户名称: "Customer Name",
  客户编码: "Customer Code",
  客户属性: "Customer Attribute",
  客户行业: "Customer Industry",
  客户地址: "Customer Address",
  客户电话: "Customer Phone",
  客户邮箱: "Customer Email",
  客户官网: "Customer Website",
  客户采购联系人: "Customer Purchase Contact",
  客户采购联系人电话: "Customer Purchase Contact Phone",
  GDNC订单号: "GDNC Order Number",
  GNDC订单号: "GNDC Order Number",
  销售渠道: "Sales Channel",
  销售: "Sales",
  设备出厂信息: "Device Factory Information",
  设备管理信息: "Device Management Information",
  商务信息: "Business Information",
  无: "None",
  在用: "In Use",
  备用: "Standby",
  报废: "Scrapped",
  制糖: "Sugar making",
  制药: "Pharmaceutical manufacturing",
  化工: "Chemical industry",
  医疗: "Medical",
  医药: "Pharmaceutical",
  啤酒: "Beer",
  市政: "Municipal",
  有机硅: "Organosilicon",
  核电: "Nuclear power",
  氨纶: "Spandex",
  污水: "Sewage",
  油气: "Oil and gas",
  炭黑: "Carbon black",
  烟草: "Tobacco",
  煤化工: "Coal chemical industry",
  煤炭: "Coal",
  煤矿: "Coal mine",
  电力: "Electric power",
  电子: "Electronics",
  石化: "Petrochemical",
  矿业: "Mining",
  粮油: "Grain and oil",
  纤维: "Fiber",
  设备: "Equipment",
  轮胎: "Tire",
  通用: "General",
  造纸: "Papermaking",
  造纸配套户: "Papermaking supporting users",
  配套: "Supporting",
  酵母: "Yeast",
  钢铁: "Steel",
  铝业: "Aluminum industry",
  铸造: "Foundry",
  食品: "Food",
  非KA: "Non-KA",
  普通: "Ordinary",
  KA: "KA",
  配套户: "Supporting User",
  工程公司: "Engineering Company",
  出口: "Export",
  设备管理: "Device Management",
  售后服务: "After-Sales Service",
  商业伙伴: "Business Partners",
  系统管理: "System Management",
  个人中心: "Personal Centre",
  产品库: "Product Library",
  查看产品信息: "View Product Information",
  新建产品: "Create New Product",
  编辑产品: "Edit Product",
  查看产品文件资料: "View Product Document Data",
  删除产品: "Delete Product",
  查看设备详情: "View Device Details",
  添加设备: "Add Device",
  编辑设备: "Edit Device",
  删除设备: "Delete Device",
  二维码绑定: "QR Code Binding",
  服务请求: "Service Request",
  查看: "View",
  添加: "Add",
  编辑: "Edit",
  工单管理: "Work Order Management",
  确认派工: "Confirm Dispatch",
  申请转派: "Apply for Reassignment",
  编辑接单服务商信息: "Edit Order Taking Service Provider Information",
  编辑接单工程师信息: "Edit Order Taking Engineer Information",
  其它信息编辑: "Other Information Edit",
  工单受理人: "Order Receiver",
  服务报告: "Service Report",
  附件上传: "Attachment Upload",
  附件下载: "Attachment Download",
  商机管理: "Opportunity Management",
  保养计划: "Maintenance Plan",
  设备制造商: "Device Manufacturer",
  其余信息: "Other Information",
  企业账户: "Enterprise Account",
  代理商: "Agent",
  终端客户: "End Customer",
  权限管理: "Privilege Management",
  用户管理: "User Management",
  列表: "List",
  冻结: "Freeze",
  修改: "Modify",
  重置密码: "Reset Password",
  角色管理: "Role Management",
  删除: "Delete",
  个人信息: "Personal Information",
  企业信息: "Enterprise Information",
  下载中: "Downloading...",
  // 智能运维页面
	smart_OM_model:{
		smart_OM:"Smart O&M",
		start_time:"Start Time:",
		end_time:"Stop Time:",
		model_status:"Model Status",
    real_time_monitoring:"Real-time Monitoring",
    intelligent_total_running_time:"Intelligent Total Running Time",
    key_metrics_trend:"Key Metrics Trend",
    model_logs:"Model Logs",
    last_updated:"Last Updated",
    items_selected:"items selected",
    condenser:"Condenser",
    pressure:"Pressure",
		temperature:"Temperature",
		power:"Power",
		motor_frequency:"Motor Frequency",
		flow_rate:"Flow Rate",
		current:"Current",
		motor_speed:"Motor Speed",
		valve:"Valve",
    separator_level:"Separator Level",		
    open:"Open",
		closed:"Closed",
    t_sealing_water:"T_sealing water",
		liquid_ring:"3#Liquid ring",
		two_roots:"2#Roots",
		one_roots:"1#Roots",
		water_pump:"1#Water Pump",
		two_speed_pump:"Two-speed Pump",
		high_speed:"High Speed",
		low_speed:"Low Speed",
		activate_smart_OM_modle:"Activate Smart O&M Mode?",
		close_smart_OM_modle:"Close Smart O&M Mode?"

	},
  // 智能运维页面---造纸厂
  smart_OM_model_paper_making:{
    fault_name:"Fault Name",//故障名称
    surge:"Surge",//喘振
    gradual_increase_in_vibration_levels:"Gradual increase in vibration levels. (from 0.3–0.9 at initial operation to above 2.0 after several months of runtime)",//振动缓慢增加(振动水平从一开始的0.3-09经过几个月的运行增长到2.0以上)
    residual_fibers_and_other_particulates_remaining_after:"Residual fibers and other particulates remaining after filtration adhered to the impeller, resulting in increased vibration.",//经过过滤剩余的纤维等附着在叶轮上导致振动增加
    we_have_developed_an_intelligen_spray:"We have developed an intelligent spray cleaning system specifically for this issue, which effectively reduces impeller cleaning time.",//我方针对此类问题开发智能喷淋系统，可有效较低叶轮清洗时间
    sudden_increase_in_vibration_fluctuations:"Sudden increase in vibration and fluctuations in vacuum level.",//振动突然增加，真空度波动
    a_sudden_drop_in_system_pumping_speed_due:"A sudden drop in system pumping speed due to process-related reasons caused the turbine to enter the surge zone.",//系统抽速由于工艺等原因突然降低导致透平机进入喘振区
    we_provide_an_intelligent_antisurge_control_logic:"We provide an intelligent anti-surge control logic. During normal operation, the system is prevented from entering the surge zone. When process conditions cause the system to approach surge, the bypass air valve will be automatically activated.",//提供智能防喘控制逻辑，正常运行时无法进入喘振区，工艺原因导致设备即将进入喘振时即自动开启补气阀
    energy_efficiency_realtime_monitoring:"Energy Efficiency Real-time Monitoring",//能效实时监测
    suction_volumetric_flow:"Suction volumetric flow [m³/s]",//吸入体积流量 [m³/s]
		vacuum:"Vacuum [kPa]",//真空度 [kPa]
    surge_warning:"Surge Warning",//喘振预警
    this_inspection_indicates_good:"This inspection indicates good health with no surge risk and no fouling risk.",//本次监测健康，无喘振风险，无结垢风险
  }
};
